/* Big Gun V2 layer JS. Additive and nil-safe: every feature checks for its
   markup and does nothing when it is absent. Garage logic stays in
   bge-garage.js (window.BGE.Garage); this file only reads it.
   Config comes from window.BGV2 (layout/theme.liquid), which mirrors Theme
   settings > Big Gun V2 so JS and Liquid read the same vocabulary. */
(function () {
  'use strict';

  var CFG = window.BGV2 || {};
  var STR = CFG.strings || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // Shopify money format ("${{amount}}") -> "$1,234.56"
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var withDec = n.toFixed(2);
    var noDec = Math.round(n).toString();
    var parts = withDec.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec.replace('.', ','))
      .replace(/<[^>]+>/g, '');
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).catch(function () { throw new Error('Could not add. Try again.'); }).then(function (r) {
      // Shopify's own message when it sends one ("only 2 left"); a dropped connection or a non-JSON page (a 429)
      // gets the house line, never "Failed to fetch" or "Unexpected token '<'" (CR-07).
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok || !j) throw new Error((j && (j.description || j.message)) || 'Could not add. Try again.');
        return j;
      });
    });
  }

  function getJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; });
  }
  // The cart once per page for the PDP readers (buy box tuner, Questions card): one /cart.js, shared, for the load read
  // only. After an add or a drawer change a reader takes cartJsonFresh(), which also replaces the shared copy: the cached
  // one is the cart from before the add (FL5-04: the Questions card kept offering the pair after the pipe went in alone).
  var cartJsonP = null;
  function cartJsonOnce() { if (!cartJsonP) cartJsonP = getJSON('/cart.js').catch(function () { return null; }); return cartJsonP; }
  // The tuner and the Questions card both re-read on the same event: one fetch serves both.
  var cartFreshAt = 0;
  function cartJsonFresh() {
    var now = Date.now();
    if (cartJsonP && now - cartFreshAt < 300) return cartJsonP;
    cartFreshAt = now;
    cartJsonP = getJSON('/cart.js').catch(function () { return null; });
    return cartJsonP;
  }
  // A box added alone (the pipe already in the cart) is not "Both added": it takes the plain Add to cart's own success
  // line (FL5-05).
  function oneDone(form) {
    var m = form && form.querySelector('[data-add-to-cart]');
    return (m && m.getAttribute('data-done')) || 'Added. Going to your cart';
  }

  function handleize(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Wait for the Garage API (bge-garage.js is deferred too and may boot later).
  function whenGarage(cb) {
    var tries = 0;
    (function poll() {
      if (window.BGE && window.BGE.Garage && typeof window.BGE.Garage.active === 'function') return cb(window.BGE.Garage);
      if (++tries > 25) return cb(null);
      setTimeout(poll, 200);
    })();
  }

  // ---------------------------------------------------------------------------
  // TFI upsell helpers (spec sections 0 and 7). Cart attribute tfi_src records
  // which surface sold the tune; it reaches the order as a Note Attribute.
  function setCartAttr(key, value) {
    var attrs = {}; attrs[key] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { /* attribution is best effort, never block the add */ });
  }
  // GA4 (gtag is loaded by the store's Google channel). Nil-safe.
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* ignore */ }
  }
  // view_promotion once per page view, when the offer enters the viewport.
  function trackPromoView(el, surface, state, pn) {
    if (!el || el.getAttribute('data-bgv2-promo-seen')) return;
    var fire = function () {
      if (el.getAttribute('data-bgv2-promo-seen')) return;
      el.setAttribute('data-bgv2-promo-seen', '1');
      track('view_promotion', { promotion_id: 'tfi_' + surface, creative_slot: state, items: pn ? [{ item_id: pn }] : [] });
    };
    if (!('IntersectionObserver' in window)) return fire();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { fire(); io.disconnect(); }
    }, { threshold: 0.5 });
    io.observe(el);
  }
  // Catalogue year tag ('09-14', '2019-2023') -> [2009, 2014]. Two-digit years at
  // or below 30 are 20xx, the rest 19xx (same rule as bgv2-year-cover.liquid).
  function yearRange(tag) {
    var m = String(tag || '').trim().match(/^(\d{2}|\d{4})-(\d{2}|\d{4})$/);
    if (!m) return null;
    var f = function (y) { y = parseInt(y, 10); return y >= 100 ? y : (y <= 30 ? 2000 + y : 1900 + y); };
    return [f(m[1]), f(m[2])];
  }
  function yearIn(year, tagsCsv) {
    var y = parseInt(year, 10);
    if (isNaN(y)) return false;
    return String(tagsCsv || '').split(',').some(function (t) { var r = yearRange(t); return r && y >= r[0] && y <= r[1]; });
  }
  // The one rule for "which TFI box is this rider's" (FAQ tune card; shared with the tuner row,
  // the drawer card and At a glance so they name the same box). rows: [{ y: year tag, ... }].
  // Only a box whose years can be read AND cover the year: a box with no readable year is never
  // offered (today every such box is a single-year "2014" box bgv2-facts cannot read yet, so
  // "no year" never means "every year"). Several cover it -> the narrowest range wins (some
  // 15-17 boxes carry a 15-23 tag that overlaps the 18-19 box); a tie keeps collection order.
  // null -> the caller shows the call-us line, never a guess.
  function tfiBoxForYear(rows, year) {
    var best = null, bestSpan = Infinity;
    (rows || []).forEach(function (row) {
      var r = row && row.y ? yearRange(row.y) : null;
      if (!r || !yearIn(year, row.y)) return;
      if (r[1] - r[0] < bestSpan) { best = row; bestSpan = r[1] - r[0]; }
    });
    return best;
  }
  // The years each box WINS under tfiBoxForYear across a span, for year labels that never
  // overlap (a 15-17 box tagged 15-23 next to an 18-19 box reads "2015 to 2017 and 2020 to
  // 2023", the 18-19 box "2018 to 2019"). from/to: the pipe's years; missing, the rows' own
  // span. Returns [{ row, years: [...], label: '2015 to 2017 and 2020 to 2023' }] in year
  // order; a box that wins no year is left out.
  function tfiBoxWins(rows, from, to) {
    if (!from || !to) {
      (rows || []).forEach(function (r) { var rr = yearRange(r && r.y); if (!rr) return; from = from ? Math.min(from, rr[0]) : rr[0]; to = to ? Math.max(to, rr[1]) : rr[1]; });
    }
    var out = [], byV = {};
    if (!from || !to || to < from || to - from > 60) return out;
    for (var y = from; y <= to; y++) {
      var b = tfiBoxForYear(rows, y);
      if (!b) continue;
      var k = String(b.v);
      if (!byV[k]) { byV[k] = { row: b, years: [] }; out.push(byV[k]); }
      byV[k].years.push(y);
    }
    out.forEach(function (w) {
      var parts = [], s0 = w.years[0], prev = s0;
      for (var i = 1; i <= w.years.length; i++) {
        var cur = w.years[i];
        if (cur === prev + 1) { prev = cur; continue; }
        parts.push(s0 === prev ? String(s0) : s0 + ' to ' + prev);
        s0 = prev = cur;
      }
      w.label = parts.join(' and ');
    });
    return out;
  }
  // Shared with the drawer upsell (bgv2-upsell.js loads after this file), so every surface
  // names the same box (CR-47, CR-48) and the same year labels (wins).
  // The year that picks a box (FL1-02; PDP spec "any saved machine fits"): the saved machines with a model and a
  // year that FIT this pipe, the active one first. One of them, or several whose years pick the same box: that
  // year. Several whose years pick different boxes, or none that fits (a machine that does not fit, or one with no
  // model, never picks a box): no year, so the rider gets the year choices, never a one-tap add of the wrong box.
  // rows: the boxes on offer ({ y, v, k }). Returns { year, vehicle } or { year: null, conflict }.
  function tuneYear(garage, tags, rows) {
    var B = window.BGE || {};
    if (!garage) return { year: null };
    if (typeof garage.list !== 'function' || typeof B.checkFitment !== 'function' || typeof B.parseTags !== 'function') {
      var b = bestOf(garage, tags);
      return (b.vehicle && b.state === 'fits' && b.vehicle.model && b.vehicle.year) ? { year: b.vehicle.year, vehicle: b.vehicle } : { year: null };
    }
    var parsed = B.parseTags(tags || ''), a = typeof garage.active === 'function' ? garage.active() : null;
    var vs = garage.list() || [];
    if (a) vs = [a].concat(vs.filter(function (x) { return x && x.id !== a.id; }));
    var fitting = vs.filter(function (x) { return x && x.model && x.year && B.checkFitment(parsed, x) === 'fits'; });
    if (!fitting.length) return { year: null };
    if (fitting.length > 1 && rows && rows.length > 1) {
      var key = function (x) { var r = tfiBoxForYear(rows, x.year); return r ? String(r.v) : ''; };
      var k0 = key(fitting[0]);
      for (var i = 1; i < fitting.length; i++) if (key(fitting[i]) !== k0) return { year: null, conflict: true };
    }
    return { year: fitting[0].year, vehicle: fitting[0] };
  }
  // A box title, escaped, with its trailing year range on one line (bgv2-nw-title.liquid, FL1-27).
  function nwTitle(t) {
    var e = String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    // Only a short tail (a year range, "All Years"), as bgv2-nw-title.liquid: a size note may wrap (FL3-12).
    return e.replace(/ \(([^()]{1,11})\)$/, ' <span class="bgv2-nw">($1)</span>');
  }
  // The word for a box of this kind in the shared copy ("Power Box" in the settings): Rev Box rows read "Rev Box".
  function kindWord(k) { return k === 'rev' ? 'Rev Box' : (k === 'mixed' ? 'box' : 'Power Box'); }
  function kindText(text, k) { return k === 'rev' || k === 'mixed' ? String(text || '').replace(/TFI Power Box|Power Box/g, kindWord(k)) : String(text || ''); }
  window.BGV2Tfi = { forYear: tfiBoxForYear, yearRange: yearRange, wins: tfiBoxWins, tuneYear: tuneYear, kindWord: kindWord, kindText: kindText };

  // After an add: open the slide-out cart when it is on the page (bgv2-cart-drawer.js),
  // otherwise go to /cart as before.
  function goCart() {
    if (window.BGV2CD && typeof window.BGV2CD.refresh === 'function') { window.BGV2CD.refresh({ open: true }); return; }
    window.location.href = '/cart';
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.disabled = !!on;
  }

  // ---------------------------------------------------------------------------
  // Collection intro: phone-width Read more / Read less toggle.
  // Markup: sections/collection-header.liquid ([data-bgv2-intro] > [data-bgv2-intro-toggle]).
  function initCollectionIntro() {
    var wraps = qsa('[data-bgv2-intro]');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var btn = qs('[data-bgv2-intro-toggle]', wrap);
      if (!btn || btn.getAttribute('data-bgv2-bound')) return;
      btn.setAttribute('data-bgv2-bound', '1');
      var more = btn.getAttribute('data-more') || btn.textContent;
      var less = btn.getAttribute('data-less') || more;
      btn.addEventListener('click', function () {
        var open = !wrap.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? less : more;
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Garage links: any <a href="...#garage"> or [data-bgv2-open-garage] opens the
  // Garage drawer (hero "Find parts for my machine", nav rows). Any
  // <a href="...#shop-by-vehicle"> scrolls to the home tiles.
  function initGarageLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href], [data-bgv2-open-garage]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.hasAttribute('data-bgv2-open-garage') || /#garage$/.test(href)) {
        if (window.BGE && typeof window.BGE.openGarage === 'function') {
          e.preventDefault();
          window.BGE.openGarage();
        }
        return;
      }
      if (/#shop-by-vehicle$/.test(href)) {
        var target = qs('#shop-by-vehicle') || qs('[data-bgv2-sbv]');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      }
    });

    // Deep link: a page that loads with #garage (Klaviyo email links) opens the
    // drawer. bge-garage.js is deferred ahead of this file, so openGarage is
    // normally there already; retry briefly in case it is not. URL left as is.
    if (window.location.hash === '#garage') {
      var tries = 0;
      (function openOnLoad() {
        if (window.BGE && typeof window.BGE.openGarage === 'function') {
          window.BGE.openGarage();
        } else if (tries++ < 30) {
          setTimeout(openOnLoad, 100);
        }
      })();
    }
  }

  // ---------------------------------------------------------------------------
  // Product page: stock line, tuner pair price, add-both, sticky bar.
  function initProduct() {
    var form = qs('form[data-product-form]');
    var stock = qs('[data-bgv2-stock]');
    if (!form) return;

    var prices = {}, avail = {};
    if (stock) {
      try { prices = JSON.parse(stock.getAttribute('data-prices') || '{}'); } catch (err) { prices = {}; }
      try { avail = JSON.parse(stock.getAttribute('data-avail') || '{}'); } catch (err) { avail = {}; }
    }
    function variantId() {
      var input = form.querySelector('[name="id"]');
      return input ? String(input.value) : '';
    }
    function qty() {
      var q = form.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }

    var tuner = qs('[data-bgv2-tuner]');
    var pairEl = tuner ? qs('[data-bgv2-pair]', tuner) : null;
    // Read on every sync: initTunerGarage swaps the box for the rider's year (CR-47).
    function tunerPrice() { return tuner ? parseInt(tuner.getAttribute('data-tuner-price') || '0', 10) : 0; }
    var stickyPrice = qs('[data-bgv2-sticky-price]');
    var stickyBtn = qs('[data-bgv2-sticky-add]');

    function sync() {
      var id = variantId();
      if (stock && Object.prototype.hasOwnProperty.call(avail, id)) {
        var ok = avail[id] === 1 || avail[id] === true;
        stock.classList.toggle('is-in', ok);
        stock.classList.toggle('is-out', !ok);
        var t = qs('[data-bgv2-stock-text]', stock);
        if (t) t.textContent = ok ? (stock.getAttribute('data-in') || '') : (stock.getAttribute('data-out') || '');
        if (stickyBtn) stickyBtn.disabled = !ok;
      }
      if (Object.prototype.hasOwnProperty.call(prices, id)) {
        // The pipe already in the cart: the box alone, at its own price (FL3-21 TUNER-INCART).
        var pipeIn = tuner && tuner.__cartIds && tuner.__cartIds[id];
        if (pairEl) pairEl.textContent = money((pipeIn ? 0 : prices[id]) + tunerPrice());
        // Dealers keep the dealer price the server and bgv2-pdp.js wrote (CR-02).
        var dp = CFG.isDealer && window.BGE_DEALER_PRICES && window.BGE_DEALER_PRICES[id];
        if (stickyPrice) stickyPrice.textContent = dp ? dp.d : money(prices[id]);
      }
    }
    // The theme has sync + async variant handlers writing [name="id"]; fire twice.
    document.addEventListener('change', function (e) {
      if (!form.contains(e.target)) return;
      setTimeout(sync, 0); setTimeout(sync, 200);
    });

    // Add both (pipe + tune). Opt-in: nothing is added without this tap.
    var addBoth = tuner ? qs('[data-bgv2-add-both]', tuner) : null;
    if (addBoth) {
      var tState = tuner.getAttribute('data-state') || 'full';
      var tPn = tuner.getAttribute('data-tuner-pn') || '';
      trackPromoView(tuner, 'pdp', tState, tPn);
      addBoth.addEventListener('click', function () {
        var tv = tuner.getAttribute('data-tuner-variant');
        tPn = tuner.getAttribute('data-tuner-pn') || tPn;
        var id = variantId();
        if (!tv || !id) return;
        busy(addBoth, true);
        track('select_promotion', { promotion_id: 'tfi_pdp', creative_slot: tState, items: [{ item_id: tPn }] });
        var boxOnly = !!(tuner.__cartIds && tuner.__cartIds[id]);
        addItems(boxOnly ? [{ id: tv, quantity: 1 }] : [{ id: id, quantity: qty() }, { id: tv, quantity: 1 }]).then(function () {
          track('add_to_cart', { item_list_id: 'tfi_pdp', items: [{ item_id: tPn, quantity: 1 }] });
          // tfi_src credits a Power Box sale; a Rev Box pair is not one (FL1-02).
          return tuner.getAttribute('data-kind') === 'rev' ? null : setCartAttr('tfi_src', 'pdp_pair');
        }).then(function () {
          if (tuner.getAttribute('data-kind') === 'tfi') tfiSessionAdd('bgv2_tfi_added', tuner.getAttribute('data-fit'));
          addBoth.classList.add('is-done');
          addBoth.textContent = boxOnly ? oneDone(form) : addBoth.getAttribute('data-done-text') || STR.added || 'Added';
          goCart();
        }).catch(function (err) {
          busy(addBoth, false);
          addBoth.textContent = err.message || 'Could not add';
        });
      });
    }
    if (tuner) initTunerGarage(tuner);
    // Which pipes are in the cart: with this pipe there, the tuner offers the box alone, as the Questions card and the
    // drawer do (FL3-21 TUNER-INCART).
    function takeCart(c) {
      if (!c) return;
      var ids = {};
      (c.items || []).forEach(function (i) { ids[String(i.variant_id)] = true; });
      tuner.__cartIds = ids;
      sync();
      if (tuner.__cartRelabel) tuner.__cartRelabel();
    }
    if (tuner) {
      cartJsonOnce().then(takeCart);
      // The cart changed on this page (the pipe added alone, a line removed in the drawer): read it again, so the buy box
      // offers the box alone once the pipe is in, as the Questions card does (FL4-02, call 24).
      var cartT = 0;
      var reread = function () { clearTimeout(cartT); cartT = setTimeout(function () { cartJsonFresh().then(takeCart); }, 150); };
      document.addEventListener('bgv2:cart:added', reread);
      document.addEventListener('bgv2:cart:change', reread);
    }
    initLinkSource(form, variantId);

    // Sticky bar: show once the main Add to cart has scrolled above the viewport.
    var sticky = qs('[data-bgv2-sticky]');
    var mainBtn = form.querySelector('[data-add-to-cart]');
    if (sticky && mainBtn) {
      var show = function (on) {
        if (on && sticky.hidden) { sticky.hidden = false; void sticky.offsetHeight; }
        if (!on && !sticky.hidden) setTimeout(function () { if (!sticky.classList.contains('is-visible')) sticky.hidden = true; }, 260);
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        document.body.classList.toggle('bgv2-sticky-on', on);
      };
      var evaluate = function () {
        var r = mainBtn.getBoundingClientRect();
        show(r.bottom < 0);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function () { evaluate(); }, { threshold: 0 }).observe(mainBtn);
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { evaluate(); ticking = false; });
      }, { passive: true });
      if (stickyBtn) stickyBtn.addEventListener('click', function () { mainBtn.click(); });
      evaluate();
    }
  }

  // Links into a TFI PDP from outside the theme carry ?tfi_src= (thank-you page
  // block, order confirmation email). The PDP copies it into the cart attribute
  // once this product is really in the cart after an Add to cart tap, so the
  // order's Note Attributes credit the link. Express checkout skips the cart and
  // cannot carry it.
  var LINK_SOURCES = ['thankyou_link', 'email'];
  function initLinkSource(form, variantId) {
    var src = '';
    try { src = new URLSearchParams(window.location.search).get('tfi_src') || ''; } catch (e) { return; }
    if (LINK_SOURCES.indexOf(src) < 0) return;
    // Armed by the Add tap, written when the add has landed (bgv2:cart:added), however long it takes: a fixed
    // 1.8 s wait lost the attribute on a slow add (CR-10).
    var armed = 0;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-add-to-cart], [data-sticky-btn-addToCart], [data-bgv2-sticky-add]')) return;
      armed = Date.now();
    });
    document.addEventListener('bgv2:cart:added', function (e) {
      if (!armed || Date.now() - armed > 60000) return;
      armed = 0;
      var id = String(variantId());
      var items = (e.detail && e.detail.items) || [];
      var hit = items.some(function (i) { return String(i.variant_id || i.id) === id; });
      (hit ? Promise.resolve(true) : getJSON('/cart.js').then(function (cart) {
        return !!(cart && cart.items.some(function (i) { return String(i.variant_id) === id; }));
      })).then(function (inCart) {
        if (inCart) { setCartAttr('tfi_src', src); track('add_to_cart', { item_list_id: 'tfi_' + src }); }
      }).catch(function () {});
    });
  }

  // PDP tuner row: when the saved machine is this pipe's machine, print the
  // rider's own year ("2019 Yamaha Raptor 700") and settle a partial row: Garage
  // year inside the TFI years -> full wording (State A), outside -> the jetting
  // note (State D). Re-runs on Garage change; the server render is the fallback.
  // Fit across every saved machine (BGE.Garage.best), falling back to the active one on an older garage.js.
  function bestOf(garage, tags) {
    if (!garage) return { state: 'unknown', vehicle: null };
    if (typeof garage.best === 'function') return garage.best(tags);
    var v = garage.active();
    return { state: v ? garage.fits(tags) : 'unknown', vehicle: v };
  }
  function initTunerGarage(tuner) {
    var machines = qsa('[data-bgv2-machine]', tuner);
    machines.forEach(function (m) { m.setAttribute('data-bgv2-machine-orig', m.textContent); });
    var h = qs('[data-bgv2-tuner-h]', tuner), line = qs('[data-bgv2-tuner-line]', tuner);
    var fit = qs('[data-bgv2-tuner-fit]', tuner), facts = qs('[data-bgv2-tuner-facts]', tuner);
    var alt = tuner.nextElementSibling && tuner.nextElementSibling.hasAttribute('data-bgv2-tuner-alt') ? tuner.nextElementSibling : null;
    var orig = { h: h ? h.innerHTML : '', line: line ? line.innerHTML : '' };
    var state = tuner.getAttribute('data-state');

    // CR-47(b). Every in-stock box for this pipe ([data-bgv2-tuner-rows], cr47-server). The
    // server shows the first; here the rider's year picks the box with the shared rule
    // (tfiBoxForYear, same as the FAQ card and the drawer), and with no machine on a pipe
    // with several year bands each box is offered by its years. No rows: today's row stands.
    var rows = [];
    try { var rj = qs('[data-bgv2-tuner-rows]', tuner); rows = rj ? (JSON.parse(rj.textContent || '[]') || []) : []; } catch (e) { rows = []; }
    var form = qs('form[data-product-form]');
    var card = qs('.bgv2-tuner__card', tuner), addBoth = qs('[data-bgv2-add-both]', tuner);
    var el = { title: qs('[data-bgv2-tuner-title]', tuner), img: qs('[data-bgv2-tuner-img]', tuner), pn: qs('[data-bgv2-tuner-pn]', tuner), warr: qs('[data-bgv2-tuner-warr]', tuner),
      price: qs('[data-bgv2-tuner-price]', tuner), pair: qs('[data-bgv2-pair]', tuner) };
    var def = {
      v: tuner.getAttribute('data-tuner-variant'), p: parseInt(tuner.getAttribute('data-tuner-price') || '0', 10), k: tuner.getAttribute('data-kind') || 'tfi',
      pn: tuner.getAttribute('data-tuner-pn') || '', y: tuner.getAttribute('data-tuner-years') || '',
      t: el.title ? el.title.textContent : '', u: el.title ? el.title.getAttribute('href') : '',
      img: el.img ? el.img.getAttribute('src') : '', alt: el.img ? el.img.getAttribute('alt') : '',
      pnText: el.pn ? el.pn.textContent : '', priceText: el.price ? el.price.textContent : '', warrText: el.warr ? el.warr.textContent : ''
    };
    var bands = rows.map(function (r) { return r.y; }).filter(function (y, i, a) { return y && a.indexOf(y) === i; });
    var pipePrices = {};
    try { pipePrices = JSON.parse(tuner.getAttribute('data-prices') || '{}'); } catch (e) { pipePrices = {}; }
    function pipeId() { var i = form && form.querySelector('[name="id"]'); return i ? String(i.value) : ''; }
    function pipeQty() { var q = form && form.querySelector('[name="quantity"]'); var n = q ? parseInt(q.value, 10) : 1; return isNaN(n) || n < 1 ? 1 : n; }
    function pipeInCart() { var ids = tuner.__cartIds; return !!(ids && ids[pipeId()]); }
    function pairText(boxCents) { if (pipeInCart()) return money(boxCents); var pp = pipePrices[pipeId()]; return pp == null ? '' : money(pp * pipeQty() + boxCents); }
    function yearsLabel(y) { var r = yearRange(y); return r ? (r[0] === r[1] ? String(r[0]) : r[0] + ' to ' + r[1]) : ''; }
    function escT(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    var shown = null; // the row on screen, null = the server's box
    // Call 76 (FL2-06): a 'partial' row's add is the server's self-attest ("Mine is a 2006. Add pipe and Rev Box");
    // a saved machine inside the box's years gets the usual add label, everyone else keeps the attest.
    // FL3-08: the attest sentence is its own span ahead of the label; the label keeps the kind word unsplit.
    var addSpan = addBoth ? (qs('[data-bgv2-add-label]', addBoth) || addBoth.querySelector('span')) : null;
    var attestEl = addBoth ? qs('[data-bgv2-attest]', addBoth) : null;
    var addAttest = addSpan ? addSpan.innerHTML : '';

    // Put one box in the row: the attributes initProduct reads at sync and click time, the
    // visible name, photo, part number and price, and the pair total.
    function setBox(box) {
      if ((box ? box.v : null) === (shown ? shown.v : null) && box) { if (el.pair) el.pair.textContent = pairText(box.p) || el.pair.textContent; return; }
      shown = box;
      var b = box || { v: def.v, p: def.p, pn: def.pn, y: def.y, t: def.t, u: def.u, img: def.img };
      tuner.setAttribute('data-tuner-variant', b.v);
      // The box's own kind: Power Box attribution and the Power Box session note follow it (FL1-02).
      tuner.setAttribute('data-kind', box && box.k ? box.k : def.k);
      tuner.setAttribute('data-tuner-price', String(b.p));
      tuner.setAttribute('data-tuner-pn', b.pn || '');
      tuner.setAttribute('data-tuner-years', b.y || def.y);
      if (el.title) { el.title.innerHTML = nwTitle(b.t); if (b.u) el.title.setAttribute('href', b.u); }
      if (el.img && b.img) { el.img.setAttribute('src', b.img); el.img.setAttribute('alt', box ? (box.k === 'rev' ? 'Rev Box' : 'TFI Power Box') + ' for ' + yearsLabel(b.y) : def.alt); }
      if (el.pn) {
        el.pn.textContent = box ? (def.pn && def.pnText.indexOf(def.pn) >= 0 ? def.pnText.replace(def.pn, b.pn || '') : (b.pn ? 'Part # ' + b.pn : '')) : def.pnText;
        // A box with no part number: no dangling "Part #", and no separator dot after it.
        var noPn = box && !b.pn;
        el.pn.hidden = !!noPn;
        var dot = el.pn.nextElementSibling;
        if (dot && dot.classList.contains('bgv2-dot')) dot.hidden = !!noPn;
      }
      if (el.price) el.price.textContent = box ? money(b.p) : def.priceText;
      // The box's own warranty term on a pipe whose boxes mix kinds (FL4-06): a TFI Power Box never reads the Rev term.
      if (el.warr) {
        var wk = box && box.k ? box.k : def.k, wt = tuner.getAttribute(wk === 'rev' ? 'data-warr-rev' : 'data-warr-tfi');
        el.warr.textContent = box && wt ? wt : def.warrText;
      }
      if (el.pair) { var t = pairText(b.p); if (t) el.pair.textContent = t; }
    }

    // No year to pick by (no fitting machine, or fitting machines whose years pick different boxes) and several
    // boxes split by year: each box as "For 2014: ..." with its own add. The server already renders these in the
    // 'choose' state (FL1-05) and they are adopted here, so nothing swaps at hydration; built here only when the
    // server rendered one box. A box whose years cannot be read is listed by its title with a link, no add.
    var choices = qs('[data-bgv2-tuner-choices]', tuner), choicesBound = false;
    var kinds = tuner.getAttribute('data-kinds') || '';
    function addLabel(k) {
      // The pipe already in the cart: "Add the Power Box" / "Add the Rev Box" (FL3-21).
      if (pipeInCart()) return kindText(tuner.getAttribute('data-add-one') || 'Add the Power Box', k);
      var l = k === 'rev' ? tuner.getAttribute('data-add-rev') : tuner.getAttribute('data-add-tfi');
      return l || (addSpan ? addSpan.textContent : '');
    }
    // The kind word kept on one line in an add label ("Add pipe and Rev Box", FL3-08), escaped first.
    function kindNw(t) { return escT(t).replace(/(Rev Box|Power Box)/, '<span class="bgv2-nw">$1</span>'); }
    // The cart arrived (initProduct): every add on the row reads box-alone or pipe-and-box again, with its price.
    tuner.__cartRelabel = function () {
      if (addSpan) addSpan.innerHTML = kindNw(addLabel(tuner.getAttribute('data-kind') || def.k));
      if (el.pair) { var tp = pairText(parseInt(tuner.getAttribute('data-tuner-price') || '0', 10)); if (tp) el.pair.textContent = tp; }
      qsa('[data-bgv2-tuner-row-add]', tuner).forEach(function (rb) {
        var li = rb.closest('[data-p]'), sp = rb.querySelector('span'), pr = rb.querySelector('[data-bgv2-row-pair]');
        if (sp) sp.textContent = addLabel(rb.getAttribute('data-k') || 'tfi');
        if (pr && li) { var t = pairText(parseInt(li.getAttribute('data-p'), 10)); if (t) pr.textContent = t; }
      });
    };
    function bindChoices() {
      if (!choices || choicesBound) return;
      choicesBound = true;
      choices.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-bgv2-tuner-row-add]');
        if (!btn || btn.disabled) return;
        var id = pipeId(), v = btn.getAttribute('data-v'), pn = btn.getAttribute('data-pn') || '', k = btn.getAttribute('data-k') || 'tfi';
        if (!id || !v) return;
        var keep = btn.innerHTML;
        busy(btn, true);
        track('select_promotion', { promotion_id: 'tfi_pdp', creative_slot: 'year_choice', items: [{ item_id: pn }] });
        var alone = pipeInCart();
        addItems(alone ? [{ id: v, quantity: 1 }] : [{ id: id, quantity: pipeQty() }, { id: v, quantity: 1 }]).then(function () {
          track('add_to_cart', { item_list_id: 'tfi_pdp', items: [{ item_id: pn, quantity: 1 }] });
          // tfi_src credits a Power Box sale; a Rev Box is not one.
          return k === 'rev' ? null : setCartAttr('tfi_src', 'pdp_pair');
        }).then(function () {
          if (k !== 'rev') tfiSessionAdd('bgv2_tfi_added', tuner.getAttribute('data-fit'));
          btn.classList.add('is-done');
          btn.textContent = alone ? oneDone(form) : (addBoth && addBoth.getAttribute('data-done-text')) || STR.added || 'Added';
          goCart();
        }).catch(function (err) {
          busy(btn, false); btn.innerHTML = keep;
          var li = btn.closest('li'), msg = li && li.querySelector('.bgv2-tuner__err');
          if (li && !msg) { msg = document.createElement('p'); msg.className = 'bgv2-tuner__err'; msg.setAttribute('role', 'alert'); li.appendChild(msg); }
          if (msg) msg.textContent = err.message || 'Could not add';
        });
      });
    }
    function renderChoices(on) {
      if (!on) {
        // Out of the DOM, not just hidden: once a machine fits there is one card, and no
        // hidden choice title or add can be read or reached ahead of it.
        if (choices) { choices.remove(); choices = null; choicesBound = false; }
        if (card) card.hidden = false;
        if (addBoth) addBoth.hidden = false;
        return;
      }
      if (!choices) {
        choices = document.createElement('div');
        choices.className = 'bgv2-tuner__choices';
        choices.setAttribute('data-bgv2-tuner-choices', '');
        // Each box labelled by the years it wins over the pipe's span, so labels never overlap;
        // a box that wins no year is not offered (bg-qa, shared rule BGV2Tfi.wins).
        var span = window.BGE && window.BGE.parseTags ? window.BGE.parseTags(tuner.getAttribute('data-product-tags') || '') : {};
        var list = tfiBoxWins(rows, span.yearStart, span.yearEnd).map(function (w) { return { r: w.row, yl: w.label }; });
        if (rows.length > 1) rows.forEach(function (r) { if (!yearRange(r.y)) list.push({ r: r, yl: '', byTitle: true }); });
        var byTitle = list.some(function (c) { return c.byTitle; });
        // The list's lines read Theme settings > Big Gun V2 (Tuner: ...) through CFG.strings, same defaults (FL2-04).
        var listLabel = (STR.tunerList || '{box} by year').replace('{box}', kinds === 'rev' ? 'Rev Box' : (kinds === 'mixed' ? 'Tune' : 'Power Box'));
        var forLine = STR.tunerFor || 'For {years}';
        choices.innerHTML = '<ul class="bgv2-tuner__choice-list" aria-label="' + escT(listLabel) + '">' + list.map(function (c) {
          var r = c.r, yl = c.yl, k = r.k || 'tfi';
          return '<li class="bgv2-tuner__choice' + (r.img ? '' : ' is-noimg') + '" data-v="' + escT(r.v) + '" data-p="' + escT(r.p) + '" data-k="' + escT(k) + '">' +
            (r.img ? '<img class="bgv2-tuner__img" src="' + escT(r.img) + '" width="72" height="72" alt="" loading="lazy">' : '') +
            '<div class="bgv2-tuner__body">' + (c.byTitle ? '' : '<span class="bgv2-tuner__for">' + escT(forLine.replace('{years}', yl)) + '</span>') +
            '<a class="bgv2-tuner__title" href="' + escT(r.u) + '">' + nwTitle(r.t) + '</a>' +
            '<span class="bgv2-tuner__meta">' + (r.pn ? 'Part # ' + escT(r.pn) : '') + '</span>' +
            '<span class="bgv2-tuner__price bgv2-num">' + escT(money(r.p)) + '</span></div>' +
            // "the" until the apply() pass below sets "your" for a fitting saved machine (FL1-42, FL2-09).
            (r.a === false ? '<p class="bgv2-tuner__sold">' + escT(kindText(tuner.getAttribute('data-soldout-line') || 'The Power Box for your {model} is sold out right now. Call us about tuning.', k).replace('your {model}', '{your} {model}').replace('{model}', tuner.getAttribute('data-machine-short') || 'machine')).replace('{your}', '<span data-bgv2-your>the</span>') + '</p>' :
            c.byTitle ? '' : '<button type="button" class="bgv2-btn bgv2-btn--secondary bgv2-btn--block bgv2-tuner__add" data-bgv2-tuner-row-add data-v="' + escT(r.v) + '" data-pn="' + escT(r.pn || '') + '" data-k="' + escT(k) + '">' +
              '<span>' + escT(addLabel(k)) + '</span><span class="visually-hidden"> for ' + escT(yl) + '</span> <span class="bgv2-num" data-bgv2-row-pair>' + escT(pairText(r.p)) + '</span></button>') + '</li>';
        }).join('') + '</ul>' +
          '<p class="bgv2-tuner__choose">' + (byTitle ? '' : escT(STR.tunerNotSure || 'Not sure which year?') + ' ') + '<button type="button" class="bgv2-textlink" data-bge-action="open-drawer">' + escT(STR.tunerPickAdd || 'Add your machine to pick the box') + '</button></p>';
        (card || addBoth || tuner.lastChild).parentNode.insertBefore(choices, card || addBoth);
      }
      bindChoices();
      qsa('[data-bgv2-tuner-row-add]', choices).forEach(function (btn) {
        var li = btn.closest('[data-p]'); var t = li ? pairText(parseInt(li.getAttribute('data-p'), 10)) : '';
        var n = qs('[data-bgv2-row-pair]', btn); if (n && t && n.textContent !== t) n.textContent = t;
      });
      choices.hidden = false;
      if (card) card.hidden = true;
      if (addBoth) addBoth.hidden = true;
    }
    // The pipe's variant or quantity changed: the pair totals follow.
    if (form) form.addEventListener('change', function () {
      setTimeout(function () {
        if (shown && el.pair) { var t = pairText(shown.p); if (t) el.pair.textContent = t; }
        if (choices && !choices.hidden) renderChoices(true);
      }, 250);
    });

    // At a glance Tuning row (bgv2-pdp-specs.liquid, data-line-full / data-line-partial from the
    // driver): follows the tuner row, so the two never contradict (bg-qa P3). Missing: no change.
    var glanceRow = qs('.bgv2-glance__row[data-line-full]');
    var glanceDd = glanceRow ? qs('dd', glanceRow) : null;
    var glanceOrig = glanceDd ? glanceDd.innerHTML : '';
    function setGlance(mode, custom) {
      if (!glanceDd) return;
      var txt = custom || (mode === 'full' ? glanceRow.getAttribute('data-line-full') : mode === 'partial' ? glanceRow.getAttribute('data-line-partial') : null);
      if (txt) { if (glanceDd.textContent !== txt) fillCall(glanceDd, txt); }
      else if (glanceDd.innerHTML !== glanceOrig) glanceDd.innerHTML = glanceOrig;
    }
    // A saved year that no box covers: say it the way the FAQ card's hedge does, word for word
    // (bgv2_faqx_hedge, read from the card's data-s-hedge), naming the rider's year and model,
    // after the warranty sentence the row already leads with (RV2-G2). Never "this box" when no
    // box is on the page. The carbureted wording (bgv2_carb_hedge on) is left as it is.
    var altOrig = alt ? alt.innerHTML : '';
    var altText = alt ? alt.textContent.trim() : '';
    var efiLine = glanceRow ? (glanceRow.getAttribute('data-line-partial') || '') : '';
    var altIsEfi = !!alt && (!efiLine || altText.indexOf(efiLine.slice(0, 40)) === 0 || /years this box/i.test(altText));
    function lead(text) { var i = String(text || '').indexOf('Call us'); return i > 0 ? text.slice(0, i).trim() + ' ' : ''; }
    // Call 31: "The Power Box for your {model} is sold out right now. Call us about tuning." in the box's kind word.
    function soldLine(v, b) {
      var tpl = tuner.getAttribute('data-soldout-line') || 'The Power Box for your {model} is sold out right now. Call us about tuning.';
      return kindText(tpl, b && b.k).replace('{model}', [v.year, v.model || v.make].filter(Boolean).join(' '));
    }
    function hedgeLine(v) {
      var faq = qs('[data-bgv2-faqx="tfi"]');
      var tpl = (faq && faq.getAttribute('data-s-hedge')) || 'No Power Box covers a [machine] yet.';
      return kindText(tpl, kinds).replace('[machine]', [v.year, v.model || v.make].filter(Boolean).join(' ')) + ' Call us about tuning.';
    }
    // "Call us" as a tel: link when the store shows its phone (data-phone on the row, set by the
    // server only with show_contacts on), like the FAQ card's call link.
    var phone = tuner.getAttribute('data-phone') || '';
    function fillCall(el, text) {
      el.textContent = '';
      var i = phone ? text.indexOf('Call us') : -1;
      if (i < 0) { el.appendChild(document.createTextNode(text)); return; }
      el.appendChild(document.createTextNode(text.slice(0, i)));
      var a = document.createElement('a');
      a.className = 'bgv2-tuner__call';
      a.href = 'tel:' + phone.replace(/[^\d+]/g, '');
      a.textContent = 'Call us';
      el.appendChild(a);
      el.appendChild(document.createTextNode(text.slice(i + 7)));
    }
    function setAlt(v) {
      if (!alt || !altIsEfi) return;
      if (!v) { if (alt.innerHTML !== altOrig) alt.innerHTML = altOrig; return; }
      var link = alt.querySelector('a:not(.bgv2-tuner__call)');
      link = link ? link.cloneNode(true) : null;
      // A Rev Box row: the hedge alone (call 41, FL3-06). The warranty sentence ahead of it is the fuel-injected Power
      // Box line, wrong on a carbureted Rev pipe.
      var revRow = kinds === 'rev' || (kinds !== 'mixed' && def.k === 'rev');
      fillCall(alt, (revRow ? '' : lead(altText)) + hedgeLine(v) + ' ');
      if (link) alt.appendChild(link);
    }
    function winCount() {
      var span = window.BGE && window.BGE.parseTags ? window.BGE.parseTags(tuner.getAttribute('data-product-tags') || '') : {};
      return tfiBoxWins(rows, span.yearStart, span.yearEnd).length;
    }
    function apply(garage) {
      // every saved machine counts, the active one first (fit blocker 2)
      var b = bestOf(garage, tuner.getAttribute('data-product-tags') || '');
      var v = b.vehicle;
      var mine = !!(v && b.state === 'fits');
      var name = mine && window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : '';
      // reset to the server render first
      if (h) h.innerHTML = orig.h;
      if (line) line.innerHTML = orig.line;
      tuner.hidden = false;
      if (alt) alt.hidden = true;
      var note = qs('[data-bgv2-tuner-gap]', tuner.parentNode);
      if (note) note.hidden = true;
      if (state === 'partial') {
        if (fit) fit.hidden = false;
        if (facts) facts.hidden = true;
        var addNow = pipeInCart() ? kindNw(addLabel(def.k)) : addAttest;
        if (addSpan && addSpan.innerHTML !== addNow) addSpan.innerHTML = addNow;
        if (attestEl) attestEl.hidden = false;
      }
      // The year that picks the box: a saved machine that fits this pipe (any of them, not only the active one), and
      // none when fitting machines disagree or none fits (tuneYear, FL1-02). Then the rider's box: from the rows when
      // the server sent them, else the server's box if its years hold the year.
      var ty = tuneYear(garage, tuner.getAttribute('data-product-tags') || '', rows);
      if (ty.year) { v = ty.vehicle; mine = true; name = window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : name; }
      var unreadable = rows.some(function (r) { return !yearRange(r.y); });
      var box = null, haveBox = false, byTitleOnly = false;
      var soldBox = null;
      if (ty.year) {
        if (rows.length) { box = tfiBoxForYear(rows, ty.year); haveBox = !!box; }
        // The box that wins this year is sold out (FL1-20, call 31): the sold-out line with a link to it, never
        // another box for the year.
        if (box && box.a === false) { soldBox = box; box = null; haveBox = false; }
        else haveBox = yearIn(ty.year, def.y);
        if (!haveBox && unreadable) {
          // Several boxes whose years cannot be read (listed by title): the rider picks, never a guess. One such
          // box: keep the server's box rather than say none is listed.
          if (rows.length > 1) byTitleOnly = true;
          else { box = null; haveBox = state !== 'partial' || yearIn(ty.year, def.y); }
        }
      }
      if (ty.year && !byTitleOnly) {
        renderChoices(false);
        setBox(box);
        if (haveBox) { setGlance('full'); setAlt(null); }
        else if (soldBox) { setGlance(null, soldLine(v, soldBox)); setAlt(null); }
        // No box covers the saved year: At a glance says the hedge alone, never a "pair it with ..." lead ahead of it (FL3-10).
        else { setGlance(null, hedgeLine(v)); setAlt(v); }
        if (haveBox) {
          // One box picked for the rider's year: the full heading and line, also in 'choose', where the server line
          // spoke for every year ("Call us about the years not listed.", FL2-02).
          // The picked box's own kind: on a pipe whose choices mix a Rev Box and a Power Box (Teryx 750 08-13) the Rev
          // heading, line and add for the Rev year, the Power Box ones for the others (FL3-02).
          var bk = box && box.k ? box.k : def.k;
          var revCopy = bk === 'rev' && tuner.hasAttribute('data-h-rev');
          if (state === 'partial' || state === 'choose') {
            if (h) h.textContent = tuner.getAttribute(revCopy ? 'data-h-rev' : 'data-h-full') || '';
            if (line) line.innerHTML = tuner.getAttribute(revCopy ? 'data-line-rev' : 'data-line-full') || '';
            if (fit) fit.hidden = true;
            if (facts) facts.hidden = bk === 'rev';
          }
          if (addSpan && (state === 'partial' || state === 'choose')) addSpan.innerHTML = kindNw(addLabel(bk)) || addAttest;
          if (attestEl) attestEl.hidden = true;
          if (revCopy && glanceRow && glanceRow.hasAttribute('data-line-rev')) setGlance(null, glanceRow.getAttribute('data-line-rev'));
        } else if (soldBox) {
          tuner.hidden = true;
          if (!note) {
            note = document.createElement('p');
            note.className = 'bgv2-tuner-note';
            note.setAttribute('data-bgv2-tuner-gap', '');
            tuner.parentNode.insertBefore(note, tuner.nextSibling);
          }
          fillCall(note, soldLine(v, soldBox));
          var soldA = document.createElement('a');
          soldA.href = soldBox.u || '#';
          soldA.textContent = soldBox.t || '';
          note.appendChild(document.createTextNode(' '));
          note.appendChild(soldA);
          note.hidden = false;
        } else if (alt) {
          tuner.hidden = true;
          alt.hidden = false;
        } else if (rows.length) {
          // No box covers this year and the server sent no call-us line for it: never offer the wrong box.
          tuner.hidden = true;
          if (!note) {
            note = document.createElement('p');
            note.className = 'bgv2-tuner-note';
            note.setAttribute('data-bgv2-tuner-gap', '');
            tuner.parentNode.insertBefore(note, tuner.nextSibling);
          }
          // Sold out beats "not listed" when a box for this year exists but is out of stock (data-soldout-years, cr47-server).
          var sold = yearIn(v.year, tuner.getAttribute('data-soldout-years') || '');
          var tpl = sold ? (tuner.getAttribute('data-soldout-line') || 'The Power Box for your {model} is sold out right now. Call us about tuning.')
            : null;
          fillCall(note, tpl ? tpl.replace('{model}', [v.year, v.model].filter(Boolean).join(' ')) : hedgeLine(v));
          note.hidden = false;
        }
      } else {
        setBox(null);
        setAlt(null);
        var many = state === 'choose' || (bands.length > 1 && winCount() > 1) || (rows.length > 1 && unreadable);
        // Several boxes offered by year, no year to pick by: no single "this box" to speak of. The server already
        // says it in the 'choose' state (bgv2-pdp-specs), so At a glance keeps its own line then.
        // A list that mixes kinds: the neutral line alone, no fuel-injected lead (call 86).
        var gMix = kinds === 'mixed' && tuner.getAttribute('data-line-mixed');
        setGlance(null, many && state !== 'choose' && (gMix || efiLine) ? (gMix || lead(efiLine) + (STR.tunerPickYear || 'Pick the {box} for your year.').replace('{box}', kindWord(kinds || 'tfi'))) : null);
        renderChoices(many);
        // A saved machine fits this pipe (two fitting machines that pick different boxes land here): no "Add your
        // machine to pick the box" (FL3-09). It shows again once no saved machine fits.
        var chooseP = choices ? qs('.bgv2-tuner__choose', choices) : null;
        if (chooseP) chooseP.hidden = !!(b.vehicle && b.state === 'fits');
        if (many) {
          // The choices carry the years, so the heading and line drop the first box's years. In the server's 'choose'
          // state they are already right (the call-37 line when some years have no box), so they stay (FL1-27).
          if (fit) fit.hidden = true;
          if (state !== 'choose') {
            var hm = kinds === 'mixed' && tuner.getAttribute('data-h-mixed');
            if (h && (hm || tuner.getAttribute('data-h-full'))) h.textContent = hm || tuner.getAttribute('data-h-full');
            // A list that mixes a Rev Box and a Power Box: the neutral line (call 81), as the server says in 'choose'.
            var lm = kinds === 'mixed' && tuner.getAttribute('data-line-mixed');
            if (line && (lm || tuner.getAttribute('data-line-full'))) line.innerHTML = lm ? escT(lm) : tuner.getAttribute('data-line-full');
          }
        }
      }
      qsa('[data-bgv2-machine]', tuner).forEach(function (m) {
        m.textContent = name || m.getAttribute('data-bgv2-machine-orig') || m.textContent;
        if (!m.getAttribute('data-bgv2-machine-orig')) m.setAttribute('data-bgv2-machine-orig', m.textContent);
      });
      // "your" only when a saved machine fits this pipe; a wrong-year or other machine reads "the" (FL1-42).
      qsa('[data-bgv2-your]', tuner).forEach(function (y) { y.textContent = (b.state === 'fits' && v) ? 'your' : 'the'; });
      // A machine saved before a model was required: the server line stands (it names this
      // pipe's machine, not the rider's) and one line asks for the model. No fit claim.
      var B = window.BGE || {};
      var old = garage.list && !garage.list().length && garage.needsModel ? garage.needsModel()[0] : null;
      // Another make than the pipe: no model of it can fit, so no "Pick the model" promise (call 73).
      if (old && B.checkFitment && B.parseTags && B.checkFitment(B.parseTags(tuner.getAttribute('data-product-tags') || ''), old) === 'no_fit') old = null;
      var pick = qs('[data-bgv2-tuner-pick]', tuner);
      if (old && B.pickModelHtml) {
        if (!pick) {
          pick = document.createElement('p');
          pick.className = 'bgv2-tuner__pick';
          pick.setAttribute('data-bgv2-tuner-pick', '');
          if (h && h.parentNode) h.parentNode.insertBefore(pick, h.nextSibling); else tuner.appendChild(pick);
        }
        var key = old.id + '|' + old.year + '|' + old.make;
        if (pick.__key !== key) {
          pick.__key = key;
          var oldName = String(B.formatVehicle ? B.formatVehicle(old) : old.year + ' ' + old.make).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
          pick.innerHTML = '<span>Pick the model of your ' + oldName + ' to check this box fits it.</span> ' +
            B.pickModelHtml(old, 'bgv2-textlink', 'Pick model');
        }
        pick.hidden = false;
      } else if (pick) {
        pick.hidden = true;
      }
    }
    whenGarage(function (garage) {
      if (!garage) return;
      apply(garage);
      if (typeof garage.onChange === 'function') garage.onChange(function () { apply(garage); });
    });
  }

  // ---------------------------------------------------------------------------
  // Journey, part first: "Complete the system". Resolves the saved Garage
  // vehicle -> model collection -> popular series full system / slip-on.
  var modelHandlesPromise = null;
  function modelHandles() {
    if (!modelHandlesPromise) {
      modelHandlesPromise = CFG.modelCollectionsUrl
        ? getJSON(CFG.modelCollectionsUrl).then(function (j) { return (j && j.handles) || []; }).catch(function () { return []; })
        : Promise.resolve([]);
    }
    return modelHandlesPromise;
  }
  var CLASS_ORDER = ['Dual-Sport', 'Dirt Bike', 'UTV', 'ATV', 'Street'];
  var SERIES_ORDER = ['EXO Stainless', 'EXO R', 'EXO', 'EVO U', 'EVO R', 'EVO M', 'EVO S', 'ECO', 'Explorer', 'Ballistic', 'Banshee'];
  function classOf(tags) { for (var i = 0; i < CLASS_ORDER.length; i++) if (tags.indexOf(CLASS_ORDER[i]) >= 0) return CLASS_ORDER[i]; return ''; }
  function seriesOf(tags) { for (var i = 0; i < SERIES_ORDER.length; i++) if (tags.indexOf(SERIES_ORDER[i]) >= 0) return SERIES_ORDER[i]; return ''; }
  function firstAvailableVariant(p) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i]; return null; }
  function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }

  function initCompleteSystem() {
    var blocks = qsa('[data-bgv2-complete]');
    if (!blocks.length) return;

    function showFinder(block) {
      var card = qs('[data-bgv2-complete-card]', block), finder = qs('[data-bgv2-complete-finder]', block), all = qs('[data-bgv2-complete-all]', block);
      if (card) card.hidden = true;
      if (all) all.hidden = true;
      if (finder) finder.hidden = false;
      block.hidden = false;
    }

    function fill(block, p, handle, vehicle, popular) {
      var card = qs('[data-bgv2-complete-card]', block), finder = qs('[data-bgv2-complete-finder]', block), all = qs('[data-bgv2-complete-all]', block);
      var v = firstAvailableVariant(p);
      if (!v) return showFinder(block);
      var img = qs('[data-bgv2-complete-img]', block);
      if (img) {
        var src = p.images && p.images[0] ? p.images[0].src : (p.featured_image || '');
        if (src) { img.src = imgUrl(src, 160); img.hidden = false; } else { img.hidden = true; }
      }
      var title = qs('[data-bgv2-complete-title]', block);
      if (title) { title.textContent = p.title; title.href = '/products/' + p.handle; }
      var series = seriesOf(p.tags || []);
      var sEl = qs('[data-bgv2-complete-series]', block);
      if (sEl) { sEl.textContent = series; sEl.hidden = !series; }
      var badge = qs('[data-bgv2-complete-badge]', block);
      if (badge) {
        if (series && series === CFG.youthSeries) { badge.textContent = STR.badgeYouth || badge.textContent; badge.hidden = false; }
        else if (series && series === popular) { badge.textContent = STR.badgePopular || badge.textContent; badge.hidden = false; }
        else badge.hidden = true;
      }
      var price = qs('[data-bgv2-complete-price]', block);
      // /products.json prices are dollar strings ("904.00"), not cents like /cart.js.
      if (price) price.textContent = money(typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price);
      var add = qs('[data-bgv2-complete-add]', block);
      if (add) {
        add.setAttribute('data-variant', v.id);
        if (!add.getAttribute('data-bgv2-bound')) {
          add.setAttribute('data-bgv2-bound', '1');
          add.addEventListener('click', function () {
            busy(add, true);
            addItems([{ id: add.getAttribute('data-variant'), quantity: 1 }]).then(function () {
              add.classList.add('is-done');
              goCart();
            }).catch(function (err) { busy(add, false); add.textContent = err.message || 'Could not add'; });
          });
        }
      }
      if (all) {
        var machine = (vehicle.make || '') + ' ' + (vehicle.model || '');
        all.textContent = (STR.completeView || 'See every pipe for your {machine}').replace('{machine}', machine.trim());
        all.href = '/collections/' + handle;
        all.hidden = false;
      }
      if (finder) finder.hidden = true;
      if (card) card.hidden = false;
      block.hidden = false;
    }

    function resolve(block, garage) {
      var v = garage ? garage.active() : null;
      if (!v || !v.make) return showFinder(block);
      var handle = handleize(v.make + ' ' + (v.model || '')) + '-exhaust';
      modelHandles().then(function (handles) {
        if (handles.indexOf(handle) < 0) return showFinder(block);
        return getJSON('/collections/' + handle + '/products.json?limit=250').then(function (j) {
          var products = (j && j.products) || [];
          var exhausts = products.filter(function (p) {
            return (p.product_type === 'Full Exhaust Systems' || p.product_type === 'Slip On Mufflers') && firstAvailableVariant(p);
          });
          // The model collection spans every year; keep what fits the saved
          // year (Garage.fits reads the same year tags as the PDP panel).
          // Untagged years stay in only when nothing is a confirmed fit.
          var status = function (p) { return garage.fits((p.tags || []).join('|')); };
          var sure = exhausts.filter(function (p) { return status(p) === 'fits'; });
          exhausts = sure.length ? sure : exhausts.filter(function (p) { var s = status(p); return s !== 'wrong_year' && s !== 'no_fit'; });
          if (!exhausts.length) return showFinder(block);
          // class from the machine's products, then the popular series for it
          var counts = {};
          exhausts.forEach(function (p) { var c = classOf(p.tags || []); if (c) counts[c] = (counts[c] || 0) + 1; });
          var cls = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0] || '';
          var pop = (CFG.popular && CFG.popular[cls]) || {};
          var pick = null;
          var byType = function (type, series) {
            return exhausts.filter(function (p) { return p.product_type === type && (!series || seriesOf(p.tags || []) === series); })[0] || null;
          };
          // A series-specific part (EVO R decal, EXO packing kit) belongs on
          // that series, so it leads; otherwise the popular series for the class.
          var own = block.getAttribute('data-part-series') || '';
          if (own) pick = byType('Full Exhaust Systems', own) || byType('Slip On Mufflers', own);
          pick = pick || byType('Full Exhaust Systems', pop.full) || byType('Slip On Mufflers', pop.slip) || byType('Full Exhaust Systems') || byType('Slip On Mufflers');
          if (!pick) return showFinder(block);
          var popular = pick.product_type === 'Full Exhaust Systems' ? pop.full : pop.slip;
          fill(block, pick, handle, v, popular);
        });
      }).catch(function () { showFinder(block); });
    }

    whenGarage(function (garage) {
      blocks.forEach(function (b) { resolve(b, garage); });
      if (garage && typeof garage.onChange === 'function') {
        garage.onChange(function () { blocks.forEach(function (b) { resolve(b, garage); }); });
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Cart page + drawer: one-tap add-on rows, free-shipping line refresh.
  // sessionStorage lists of fit tags: bgv2_tfi_skip ("I already have a tune")
  // and bgv2_tfi_added (show "Power Box added" instead of the net).
  function tfiSessionList(key) {
    try { return (sessionStorage.getItem(key) || '').split('|').filter(Boolean); } catch (e) { return []; }
  }
  function tfiSessionAdd(key, fit) {
    if (!fit) return;
    try { var l = tfiSessionList(key); if (l.indexOf(fit) < 0) l.push(fit); sessionStorage.setItem(key, l.join('|')); } catch (e) { /* private mode */ }
  }

  // Cart TFI net (drawer and cart page): exit link, added status, Garage year
  // on partial nets, the rider's machine name on the net and the group label.
  // A "the" that reads "your" once a saved machine fits the pipe in data-bgv2-your-scope (its tags), outside the tuner row
  // and the cart net, which set their own: the sold-out note and the At a glance sold-out line (FL1-42, FL2-10).
  function initYourScopes() {
    var scopes = qsa('[data-bgv2-your-scope]');
    if (!scopes.length) return;
    whenGarage(function (garage) {
      if (!garage) return;
      var apply = function () {
        scopes.forEach(function (el) {
          var b = bestOf(garage, el.getAttribute('data-bgv2-your-scope') || '');
          var mine = !!(b.vehicle && b.state === 'fits');
          qsa('[data-bgv2-your]', el).forEach(function (y) { y.textContent = mine ? 'your' : 'the'; });
        });
      };
      apply();
      if (typeof garage.onChange === 'function') garage.onChange(apply);
    });
  }

  function initTfiNet() {
    var skipped = tfiSessionList('bgv2_tfi_skip');
    var added = tfiSessionList('bgv2_tfi_added');
    var nets = qsa('[data-bgv2-net="tuner"]');
    nets.forEach(function (net) {
      var fit = net.getAttribute('data-fit');
      if (skipped.indexOf(fit) >= 0) { net.hidden = true; return; }
      trackPromoView(net, 'cart', net.getAttribute('data-state') || 'full', net.getAttribute('data-tuner-pn'));
    });
    qsa('[data-bgv2-net-added]').forEach(function (el) {
      if (added.indexOf(el.getAttribute('data-bgv2-net-added')) >= 0) el.hidden = false;
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bgv2-tfi-skip]');
      if (!b) return;
      var fit = b.getAttribute('data-bgv2-tfi-skip');
      tfiSessionAdd('bgv2_tfi_skip', fit);
      track('tfi_dismiss', { fit: fit });
      qsa('[data-bgv2-net="tuner"]').forEach(function (n) { if (n.getAttribute('data-fit') === fit) n.hidden = true; });
      var group = qs('[data-bgv2-cart-group]');
      if (group) { group.setAttribute('tabindex', '-1'); group.focus(); }
    });
    var scopes = nets.concat(qsa('[data-bgv2-cart-group]'));
    if (!scopes.length) return;
    scopes.forEach(function (el) { qsa('[data-bgv2-machine]', el).forEach(function (m) { m.setAttribute('data-bgv2-machine-orig', m.textContent); }); });
    whenGarage(function (garage) {
      if (!garage) return;
      var apply = function () {
        scopes.forEach(function (el) {
          var b = bestOf(garage, el.getAttribute('data-product-tags') || '');
          var v = b.vehicle;
          var mine = !!(v && b.state === 'fits');
          var name = mine && window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : '';
          qsa('[data-bgv2-machine]', el).forEach(function (m) { m.textContent = name || m.getAttribute('data-bgv2-machine-orig'); });
          // "your" only when a saved machine fits this pipe (FL1-42, FL2-09).
          qsa('[data-bgv2-your]', el).forEach(function (y) { y.textContent = mine ? 'your' : 'the'; });
          var st = el.getAttribute('data-state');
          if ((st === 'partial' || st === 'choose') && skipped.indexOf(el.getAttribute('data-fit')) < 0) {
            // The rider's year and box by the tuner row's rule (FL2-08, call 24): a saved machine that fits this pipe
            // (tuneYear), then the box that wins that year among the picker's rows (tfiBoxForYear). No in-stock box for
            // that year: no net, never another box (FL1-20).
            var nrows = [];
            try { var nrj = qs('[data-bgv2-net-rows]', el); nrows = nrj ? (JSON.parse(nrj.textContent || '[]') || []) : []; } catch (err) { nrows = []; }
            var nty = tuneYear(garage, el.getAttribute('data-product-tags') || '', nrows);
            var nbox = nty.year && nrows.length ? tfiBoxForYear(nrows, nty.year) : null;
            var unread = nrows.length > 1 && nrows.some(function (r) { return !yearRange(r.y); });
            var inYears = !!(nbox && nbox.a !== false);
            el.hidden = !!(nty.year && !inYears && !unread);
            // Call 76: the self-attest add ("Mine is a ...") until a saved machine inside the years, then the usual add.
            var nl = qs('[data-bgv2-net-label]', el);
            if (nl) nl.textContent = nl.getAttribute(inYears ? 'data-plain' : 'data-attest') || nl.textContent;
            var nfit = qs('.bgv2-tuner__fit', el);
            if (nfit) nfit.hidden = inYears;
            // One box picked for the rider's year: its kind's full line, not the call-us tail for the other years.
            var nline = qs('.bgv2-net__line', el);
            if (nline) {
              if (el.__lineOrig == null) el.__lineOrig = nline.innerHTML;
              var nfull = inYears ? el.getAttribute(nbox.k === 'rev' ? 'data-line-rev' : 'data-line-tfi') : '';
              if (nfull) nline.textContent = nfull; else if (nline.innerHTML !== el.__lineOrig) nline.innerHTML = el.__lineOrig;
            }
            // Year choices: the rider's box only once a year picks one; every box again with no year.
            qsa('[data-bgv2-net-choices] > li', el).forEach(function (li) { li.hidden = inYears && li.getAttribute('data-v') !== String(nbox.v); });
          }
        });
      };
      apply();
      if (typeof garage.onChange === 'function') garage.onChange(apply);
    });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bgv2-cart-add]');
      if (!btn) return;
      var ids = (btn.getAttribute('data-bgv2-cart-add') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      busy(btn, true);
      var src = btn.getAttribute('data-tfi-src');
      var net = src ? btn.closest('[data-bgv2-net]') : null;
      var pn = btn.getAttribute('data-pn') || (net ? (net.getAttribute('data-tuner-pn') || '') : '');
      // A Rev Box is not a Power Box sale: no tfi_src and no Power Box session note (FL1-02, FL2-08).
      var rev = btn.getAttribute('data-k') === 'rev';
      if (src) track('select_promotion', { promotion_id: 'tfi_cart', creative_slot: net ? net.getAttribute('data-state') : '', items: [{ item_id: pn }] });
      addItems(ids.map(function (id) { return { id: id, quantity: 1 }; })).then(function () {
        if (!src) return null;
        track('add_to_cart', { item_list_id: 'tfi_cart', items: [{ item_id: pn, quantity: 1 }] });
        if (rev) return null;
        tfiSessionAdd('bgv2_tfi_added', btn.getAttribute('data-fit'));
        return setCartAttr('tfi_src', src);
      }).then(function () {
        btn.classList.add('is-done');
        if (window.BGV2CD) { goCart(); return; }
        if (/^\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        else window.location.href = '/cart';
      }).catch(function (err) { busy(btn, false); btn.textContent = err.message || 'Could not add'; });
    });

    // The theme's ajax add does not re-render the header drawer. After any
    // add-to-cart click, re-read /cart.js and refresh the free-shipping line.
    var lines = qsa('.bgv2-cart-layer--drawer [data-bgv2-ship-line]');
    if (!lines.length || !CFG.shipThreshold || CFG.isDealer) return;
    function refresh() {
      getJSON('/cart.js').then(function (cart) {
        if (!cart) return;
        var total = cart.total_price || 0;
        lines.forEach(function (line) {
          var unlocked = total >= CFG.shipThreshold;
          line.classList.toggle('is-unlocked', unlocked);
          var textEl = line.querySelector('span:last-child');
          if (!textEl) return;
          if (unlocked) textEl.textContent = STR.freeUnlocked || '';
          else textEl.textContent = (STR.freeProgress || '').replace('{amount}', money(CFG.shipThreshold - total));
          var bar = line.querySelector('.bgv2-ship-line__bar > span');
          if (bar) bar.style.width = Math.min(100, Math.round(total * 100 / CFG.shipThreshold)) + '%';
        });
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-add-to-cart], [data-sticky-btn-addToCart], .btn-remove, [data-bge-qa-add]')) setTimeout(refresh, 1800);
    });
  }

  // ---------------------------------------------------------------------------
  // Collection filters: long tag lists are truncated with CSS (no clip); the
  // "Show all" toggle expands them.
  function initFilterMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bgv2-filter-more]');
      if (!btn) return;
      var wrap = btn.closest('.sidebarBlock-content');
      if (!wrap) return;
      var open = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (btn.getAttribute('data-less') || btn.textContent) : (btn.getAttribute('data-more') || btn.textContent);
    });
  }

  // Moat-first deep links: /collections/x?bgv2_series=EVO+U moves the cards
  // tagged with that series to the front of the grid (Liquid cannot read the
  // query string, so this is a DOM move, same cards, same count).
  function initSeriesFirst() {
    var param = CFG.seriesParam || 'bgv2_series';
    var m = new RegExp('[?&]' + param + '=([^&]+)').exec(window.location.search);
    if (!m) return;
    // Comma list, in priority order (ATV tiles carry "EVO U,EVO R": the
    // slip-on and full-system leaders, since a model collection may stock one).
    var wanted = decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase().split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    var grid = qs('#Collection .halo-column-product');
    if (!grid || !wanted.length) return;
    // Collection V3 groups model grids by part type and preselects the series in its ladder instead.
    if (grid.hasAttribute('data-bgv3-grouped')) return;
    var rank = function (item) {
      var card = qs('[data-bge-tags]', item);
      if (!card) return -1;
      var tags = (card.getAttribute('data-bge-tags') || '').toLowerCase().split('|');
      for (var j = 0; j < wanted.length; j++) if (tags.indexOf(wanted[j]) >= 0) return j;
      return -1;
    };
    var matched = [];
    qsa('.halo-item', grid).forEach(function (item, idx) {
      var r = rank(item);
      if (r >= 0) matched.push({ el: item, r: r, i: idx });
    });
    matched.sort(function (a, b) { return a.r - b.r || a.i - b.i; });
    for (var i = matched.length - 1; i >= 0; i--) grid.insertBefore(matched[i].el, grid.firstChild);
    if (matched.length) grid.setAttribute('data-bgv2-series-first', wanted.join(','));
  }

  // Empty-cart "Enable cookies" copy only when cookies are actually off.
  function initCookieMessage() {
    var msg = qs('.cookie-message');
    if (msg && navigator.cookieEnabled === false) msg.classList.add('is-needed');
  }

  // Klaviyo Reviews renders its star widget client-side, and with no reviews it
  // prints five empty stars and "0 reviews" under the title. Proof with a zero
  // in it reads as a warning, so the widget stays hidden until a review exists.
  function initZeroReviews() {
    var widgets = qsa('.klaviyo-star-rating-widget');
    if (!widgets.length || !window.MutationObserver) return;
    var check = function (w) {
      var label = qs('.kl_reviews__star_rating_widget__label', w);
      if (!label) return false;
      var zero = /^\s*0\s+reviews?\s*$/i.test(label.textContent || '');
      var box = w.parentElement && w.parentElement.children.length === 1 ? w.parentElement : w;
      box.hidden = zero;
      return true;
    };
    widgets.forEach(function (w) {
      if (check(w)) return;
      var mo = new MutationObserver(function () { if (check(w)) mo.disconnect(); });
      mo.observe(w, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    });
  }

  // ---------------------------------------------------------------------------
  // Nav (2026-10-02). Desktop mega nav: snippets/bgv2-mega-nav.liquid. Hover opens a
  // panel after 120ms and closes it 200ms after the pointer leaves; once one is open,
  // moving along the bar swaps panels at once. Touch: first tap on a label opens its
  // panel, second tap follows the link. Keyboard: the chevron button next to each label
  // opens the panel and focuses its first link; Escape closes and returns focus.
  function initMegaNav() {
    var mega = qs('[data-bgv2-mega]');
    if (!mega) return;
    var items = qsa('[data-bgv2-mega-item]', mega).filter(function (li) { return qs('[data-bgv2-mega-panel]', li); });
    var openItem = null, openT = null, closeT = null, lastPointer = 'mouse';

    function setOpen(li, on) {
      li.classList.toggle('is-open', on);
      var t = qs('.bgv2-mega__toggle', li);
      if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function open(li) {
      clearTimeout(openT); clearTimeout(closeT);
      if (openItem && openItem !== li) setOpen(openItem, false);
      setOpen(li, true);
      openItem = li;
      mega.classList.add('has-open');
    }
    function closeAll() {
      clearTimeout(openT); clearTimeout(closeT);
      if (openItem) setOpen(openItem, false);
      openItem = null;
      mega.classList.remove('has-open');
    }

    items.forEach(function (li) {
      var label = qs('.bgv2-mega__label', li);
      var toggle = qs('.bgv2-mega__toggle', li);
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeT); clearTimeout(openT);
        if (openItem) open(li);
        else openT = setTimeout(function () { open(li); }, 120);
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openT);
        closeT = setTimeout(function () { if (openItem === li) closeAll(); }, 200);
      });
      if (label) {
        label.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType; });
        label.addEventListener('click', function (e) {
          var touch = lastPointer === 'touch' || lastPointer === 'pen';
          lastPointer = 'mouse';
          if (touch && openItem !== li) { e.preventDefault(); open(li); }
        });
      }
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (openItem === li) { closeAll(); return; }
          open(li);
          if (e.detail === 0) {
            var first = qs('[data-bgv2-mega-panel] a, [data-bgv2-mega-panel] button', li);
            if (first) setTimeout(function () { first.focus(); }, 30);
          }
        });
      }
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openItem === li) { closeAll(); if (toggle) toggle.focus(); }
      });
      li.addEventListener('focusout', function (e) {
        if (openItem === li && e.relatedTarget && !li.contains(e.relatedTarget)) closeAll();
      });
    });
    document.addEventListener('click', function (e) {
      if (!openItem) return;
      if (!openItem.contains(e.target)) closeAll();
      else if (e.target.closest('[data-bgv2-open-garage], [data-bge-action="open-drawer"]')) closeAll();
    });
    window.addEventListener('scroll', function () { if (openItem) closeAll(); }, { passive: true });
  }

  // Drawer: snippets/bgv2-nav-drawer.liquid inside the theme's #site-nav-mobile shell.
  // The theme still opens and closes it (body.open_menu); this adds focus handling,
  // drill-in levels with Back, "Show more", and the Close button.
  function initDrawerNav() {
    var shell = qs('#site-nav-mobile');
    var drawer = qs('[data-bgv2-drawer]');
    if (!shell || !drawer) return;
    var scroller = qs('.halo_mobileNavigation_wrapper', shell) || shell;
    var root = qs('[data-bgv2-root]', drawer);
    var toggles = qsa('[data-mobile-menu-toggle="menu"]');
    var lastToggle = null, rootScroll = 0, opener = null;
    var isOpen = function () { return document.body.classList.contains('open_menu'); };
    // The toggles are the vendor's <a role="button">: Enter clicks a link, Space does not (WG-06). Space clicks it
    // too, so the theme's own click handler opens and closes the menu either way.
    toggles.forEach(function (t) {
      t.addEventListener('keydown', function (e) {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        t.click();
      });
    });

    function close() {
      var x = qs('.close_menu', shell);
      if (window.jQuery && x) window.jQuery(x).trigger('click');
      else {
        document.body.classList.remove('open_menu');
        toggles.forEach(function (t) { t.classList.remove('is-open'); });
      }
    }
    function showLevel(level) {
      qsa('[data-bgv2-level]', drawer).forEach(function (l) {
        var on = l === level;
        l.hidden = !on;
        l.classList.toggle('is-current', on);
      });
      drawer.classList.toggle('is-drilled', level !== root);
    }
    function back(focus) {
      showLevel(root);
      scroller.scrollTop = rootScroll;
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        if (focus) opener.focus();
      }
      opener = null;
    }
    function sync() {
      var on = isOpen();
      shell.inert = !on;
      shell.setAttribute('aria-hidden', on ? 'false' : 'true');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      if (on) {
        setTimeout(function () {
          if (!isOpen()) return;
          var c = qs('[data-bgv2-drawer-close]', drawer);
          var target = c && c.offsetParent ? c : qs('a[href], button', drawer);
          if (target) target.focus({ preventScroll: true });
        }, 60);
      } else {
        if (opener) back(false);
        qsa('.bgv2-nav-group.is-expanded', drawer).forEach(function (g) { setMore(g, false); });
        if (shell.contains(document.activeElement) && lastToggle && lastToggle.offsetParent) lastToggle.focus({ preventScroll: true });
      }
    }
    function setMore(group, on) {
      var b = qs('[data-bgv2-more]', group);
      group.classList.toggle('is-expanded', on);
      if (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); b.textContent = on ? b.getAttribute('data-less') : b.getAttribute('data-more'); }
    }

    toggles.forEach(function (t) { t.addEventListener('click', function () { lastToggle = t; }); });
    if (window.MutationObserver) {
      var was = isOpen();
      new MutationObserver(function () {
        var now = isOpen();
        if (now !== was) { was = now; sync(); }
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    sync();

    drawer.addEventListener('click', function (e) {
      var drill = e.target.closest('[data-bgv2-drill]');
      if (drill) {
        var level = document.getElementById(drill.getAttribute('aria-controls'));
        if (!level) return;
        e.preventDefault();
        rootScroll = scroller.scrollTop;
        opener = drill;
        drill.setAttribute('aria-expanded', 'true');
        showLevel(level);
        scroller.scrollTop = 0;
        var b = qs('[data-bgv2-back]', level);
        if (b) b.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-bgv2-back]')) { e.preventDefault(); back(true); return; }
      var more = e.target.closest('[data-bgv2-more]');
      if (more) { e.preventDefault(); var g = more.closest('.bgv2-nav-group'); setMore(g, !g.classList.contains('is-expanded')); return; }
      if (e.target.closest('[data-bgv2-drawer-close]')) { e.preventDefault(); close(); return; }
      // The Garage opens over the page; close the menu under it.
      if (e.target.closest('[data-bgv2-open-garage], [data-bge-action="open-drawer"]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen() || document.body.classList.contains('bge-garage-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = qsa('a[href], button:not([disabled]), input, select', shell).filter(function (el) { return el.offsetParent !== null && el.getAttribute('tabindex') !== '-1'; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!shell.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Scrolled desktop: the drawer hangs under the sticky header. Back at the top the
    // header un-sticks and the hamburger goes away, so close the drawer with it.
    var header = qs('.site-header');
    window.addEventListener('scroll', function () {
      if (isOpen() && window.innerWidth > 1024 && header && !header.classList.contains('is-sticky')) close();
    }, { passive: true });
  }

  // Garage finder blocks in the drawer and the mega panels show the saved machine,
  // the same state the Garage bar shows (BGE.Garage); empty state is the server markup.
  function initNavGarage() {
    var blocks = qsa('[data-bgv2-navgarage]');
    if (!blocks.length) return;
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    blocks.forEach(function (b) { var body = qs('[data-bgv2-navgarage-body]', b); b._empty = body ? body.innerHTML : ''; });
    function render() {
      var BGE = window.BGE || {};
      var v = BGE.Garage && BGE.Garage.active ? BGE.Garage.active() : null;
      blocks.forEach(function (b) {
        var body = qs('[data-bgv2-navgarage-body]', b);
        if (!body) return;
        var old = !v && BGE.Garage.needsModel ? BGE.Garage.needsModel()[0] : null;
        b.classList.toggle('has-vehicle', !!(v || old));
        if (old && BGE.pickModelHtml) {
          // Saved before a model was required: name it and offer the one-tap fix, no parts link.
          body.innerHTML = '<p class="bgv2-navgarage__vehicle">' + esc(BGE.formatVehicle ? BGE.formatVehicle(old) : [old.year, old.make].join(' ')) + '</p>' +
            BGE.pickModelHtml(old, 'bgv2-navgarage__btn', 'Pick your model');
          return;
        }
        if (!v) { body.innerHTML = b._empty; return; }
        var name = BGE.formatVehicle ? BGE.formatVehicle(v) : [v.year, v.make, v.model].join(' ');
        var url = BGE.browseUrl ? BGE.browseUrl(v, { strict: true }) : '/collections/all';
        body.innerHTML =
          '<p class="bgv2-navgarage__vehicle">' + esc(name) + '</p>' +
          '<a class="bgv2-navgarage__btn" href="' + esc(url) + '">Shop parts that fit</a>' +
          '<button type="button" class="bgv2-navgarage__change" data-bge-action="open-drawer">Change machine</button>';
      });
    }
    render();
    setTimeout(render, 450);
    if (window.BGE && window.BGE.Garage && window.BGE.Garage.onChange) window.BGE.Garage.onChange(render);
  }

  // Photo credits under the tile sections: one line; when it runs longer a
  // "Photo credits" toggle opens the full list (the text stays in the page either way).
  // FL1-09: at 767px and below the vendor turns the footer link columns into accordions that open on a click
  // on the heading only (theme.js toggle_footer). There each heading's content sits in a real button, so Enter
  // and Space work and aria-expanded carries the state; above that width the heading is plain text again.
  function initFooterAcc() {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 767px)');
    function sync() {
      qsa('.footer-col--mobile .footer-info-heading').forEach(function (h, i) {
        var col = h.parentNode, list = qs('.footer-info-list', col);
        var btn = qs('.bgv2-footer-toggle', h);
        if (mq.matches && !btn && list) {
          list.id = list.id || 'bgv2-footer-list-' + i;
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bgv2-footer-toggle';
          btn.setAttribute('aria-controls', list.id);
          while (h.firstChild) btn.appendChild(h.firstChild);
          h.appendChild(btn);
        } else if (!mq.matches && btn) {
          while (btn.firstChild) h.insertBefore(btn.firstChild, btn);
          h.removeChild(btn);
          btn = null;
        }
        if (btn) btn.setAttribute('aria-expanded', col.classList.contains('open-dropdown') ? 'true' : 'false');
      });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    // The vendor handler on the heading runs first (the click bubbles to it), then the state is read back.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.footer-col--mobile .footer-info-heading')) sync();
    });
  }

  function initCredits() {
    qsa('[data-bgv2-credits]').forEach(function (box) {
      var text = qs('.bgv2-credits__text', box);
      var btn = qs('[data-bgv2-credits-toggle]', box);
      if (!text || !btn) return;
      var check = function () {
        if (box.classList.contains('is-open')) return;
        btn.hidden = text.scrollWidth <= text.clientWidth + 1;
      };
      btn.addEventListener('click', function () {
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Hide photo credits' : 'Photo credits';
      });
      check();
      window.addEventListener('resize', check, { passive: true });
    });
  }

  // Header search for riders (mobile audit 2026-10-03, items 12 and 28): the
  // phone search opens with the field focused (one tap, not two), and when the
  // query names a model that has its own collection, the predictive panel
  // gets a "Shop <machine> parts" row on top. Handles from
  // bge-model-collections.json ({make}-{model}-exhaust).
  var UPPER_WORDS = /^(atv|utv|rzr|xp|crf|trx|yfz|yz|wr|kx|klx|drz|ltr|ktm|sxs|xr|xr650l|ttr|pw|cr|rmz|kfx|rs|xc|xcw|sx|exc|efi|eps|hd|le|xt|xtz|ho|gt|mx)$/i;
  function modelLabel(handle) {
    var label = handle.replace(/-exhaust$/, '').split('-').map(function (w) {
      if (/\d/.test(w) || UPPER_WORDS.test(w)) return w.toUpperCase();
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
    return label.replace(/^Can Am\b/, 'Can-Am');
  }
  function matchModel(q, handles) {
    var slug = q.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    if (slug.length < 3 || !/[a-z]/.test(slug)) return null;
    var best = null;
    handles.forEach(function (h) {
      var base = h.replace(/-exhaust$/, '');
      // whole words only: "raptor-700" matches yamaha-raptor-700, not yamaha-raptor-700r
      var i = ('-' + base + '-').indexOf('-' + slug + '-');
      if (i < 0) return;
      if (!best || base.length < best.replace(/-exhaust$/, '').length) best = h;
    });
    return best;
  }
  function initSearch() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.item--searchMobile .navUser-action');
      if (!t) return;
      var input = qs('.item--searchMobile .header-search__input') || qs('.header-search__input');
      // the vendor handler has already toggled is-open; focus inside the same tap so iOS opens the keyboard
      if (input && t.classList.contains('is-open')) { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }
    });
    var label = (CFG.strings && CFG.strings.searchModel) || 'Shop {model} parts';
    var timer = null;
    // The vendor search (vendor.js "Search 2") appends "*" to every query. Shopify search already matches
    // prefixes ("rapt" finds 58 Raptor parts), and the star makes any query return the whole catalogue
    // ("rapt*", "zzqxvbg*", "09-2673*": 1000 results, part numbers buried). The query goes as typed, so a
    // part number (variant title, e.g. 09-2673) comes back as the exact part, the same as on Enter (FL1-47).
    if (window.jQuery && jQuery.ajaxPrefilter) {
      jQuery.ajaxPrefilter(function (o) {
        if (!o.url || o.url.indexOf('/search?view=json') < 0 || typeof o.data !== 'string') return;
        o.data = o.data.replace(/(^|&)q=([^&]*?)(%2A|\*)+(?=&|$)/i, '$1q=$2');
      });
    }
    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('header-search__input')) return;
      // The vendor search listens to keyup only, so paste, autofill, voice input and some phone keyboards
      // left the panel empty until Enter (FL1-47). Its own 250 ms debounce keeps typing to one request.
      if (window.jQuery) jQuery(input).trigger('keyup');
      clearTimeout(timer);
      timer = setTimeout(function () {
        var wrap = input.closest('.search-form');
        var box = wrap && qs('.quickSearchResultsWrap .custom-scrollbar', wrap);
        if (!box) return;
        modelHandles().then(function (handles) {
          var h = matchModel(input.value || '', handles);
          var row = qs('.bgv2-search-model', box);
          if (!h) { if (row) row.remove(); return; }
          if (!row) { row = document.createElement('a'); row.className = 'bgv2-search-model'; box.insertBefore(row, box.firstChild); }
          row.href = '/collections/' + h;
          row.textContent = label.replace('{model}', modelLabel(h));
        });
      }, 150);
    });
  }

  // ---------------------------------------------------------------------------
  // Order attribution without cookies (ported from BLCK ANVL src/lib/analytics.ts,
  // same keys): first and last touch utm_*, gclid, gbraid, wbraid, fbclid,
  // ttclid, ref, landing page and referrer live in localStorage, and once the
  // cart has an item they are written as cart attributes (_ft_* / _lt_*, plus
  // _fbp, _fbc, _ga_client_id when those cookies exist). Leading underscores
  // keep them out of checkout; they show on the order under Additional details.
  var ATTR_KEY = 'bgv2_attribution';
  var TOUCH_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'ref'];
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function captureAttribution() {
    try {
      var url = new URL(window.location.href);
      var touch = {}, hasTouch = false;
      TOUCH_PARAMS.forEach(function (k) { var v = url.searchParams.get(k); if (v) { touch[k] = v.slice(0, 200); hasTouch = true; } });
      var a = JSON.parse(localStorage.getItem(ATTR_KEY) || '{}');
      // the preview bar adds its own params; the landing page keeps only the touch params
      var keep = new URLSearchParams();
      TOUCH_PARAMS.forEach(function (k) { if (touch[k]) keep.set(k, touch[k]); });
      var stamp = Object.assign({}, touch, {
        landing_page: (url.pathname + (keep.toString() ? '?' + keep.toString() : '')).slice(0, 200),
        referrer: (document.referrer && document.referrer.indexOf(location.host) < 0 ? document.referrer : '').slice(0, 200),
        at: new Date().toISOString()
      });
      if (!a.first) a.first = stamp;
      if (hasTouch || !a.last) a.last = stamp;
      localStorage.setItem(ATTR_KEY, JSON.stringify(a));
    } catch (e) { /* storage blocked: nothing to carry */ }
  }
  function attributionAttrs() {
    var out = {};
    try {
      var a = JSON.parse(localStorage.getItem(ATTR_KEY) || '{}');
      // Every key of a touch is written, '' when this touch lacks it, so a new last touch clears
      // the old one's extras: a Klaviyo visit after a Google click left _lt_gclid, _lt_utm_content and
      // _lt_utm_term on the order (CR-22). Shopify drops attributes whose value is blank.
      var keys = TOUCH_PARAMS.concat(['landing_page', 'referrer']);
      [['ft', a.first], ['lt', a.last]].forEach(function (p) {
        if (!p[1]) return;
        keys.forEach(function (k) { out['_' + p[0] + '_' + k] = p[1][k] || ''; });
      });
    } catch (e) { /* ignore */ }
    var fbp = readCookie('_fbp'), fbc = readCookie('_fbc'), ga = readCookie('_ga');
    if (fbp) out._fbp = fbp;
    if (fbc) out._fbc = fbc;
    if (ga) out._ga_client_id = ga.replace(/^GA\d\.\d\./, '');
    return out;
  }
  var attrBusy = false;
  function writeAttribution() {
    if (attrBusy) return;
    attrBusy = true;
    getJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.item_count) return;
      var want = attributionAttrs(), have = cart.attributes || {}, diff = {}, n = 0;
      // blank and absent are the same, so an unchanged cart is not written again
      Object.keys(want).forEach(function (k) { if ((have[k] || '') !== (want[k] || '')) { diff[k] = want[k]; n++; } });
      if (!n) return;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: diff })
      });
    }).catch(function () { /* the order still goes through without them */ }).then(function () { attrBusy = false; });
  }
  function initAttribution() {
    captureAttribution();
    var isAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); };
    // every add path: our fetch helpers, the vendor's jQuery ajax, and the plain form post (lands on a page with items)
    if (window.fetch && !window.fetch.__bgv2attr) {
      var f0 = window.fetch;
      var f1 = function (input) {
        var p = f0.apply(this, arguments);
        var u = typeof input === 'string' ? input : (input && input.url);
        if (isAdd(u)) p.then(function (r) { if (r && r.ok) setTimeout(writeAttribution, 300); }, function () {});
        return p;
      };
      f1.__bgv2attr = true;
      window.fetch = f1;
    }
    if (window.jQuery) window.jQuery(document).on('ajaxComplete', function (e, xhr, opts) { if (opts && isAdd(opts.url) && xhr.status < 400) setTimeout(writeAttribution, 300); });
    // no cart cookie yet means no cart: skip the /cart.js read on first visits
    if (readCookie('cart')) writeAttribution();
  }

  // ---------------------------------------------------------------------------
  // PDP Questions add-on cards (FE-03 repack, FE-04 tune; snippets/bgv2-faq-offer.liquid).
  // Reads the Garage only (bestOf, the tuner row's read) and the boxes the server
  // matched for this pipe; picks the box by the saved year (yearIn). Ajax add, the
  // drawer opens, cart attribute repack_src / tfi_src = pdp_faq, then "In your cart".
  function initFaqOffers() {
    var cards = qsa('[data-bgv2-faqx]');
    if (!cards.length) return;
    var form = qs('form[data-product-form]');
    var inCart = {};
    var renders = [];
    var garageRef = null; // BGE.Garage once it boots
    // After an add the button turns into "In your cart", so the drawer's focus return target is gone.
    // The card that added remembers how to finish; on drawer close it settles and takes focus (bg-review FE-03 #1).
    var returnTo = null;
    function renderAll() { renders.forEach(function (f) { f(); }); }
    function pipeVariant() { var i = form && form.querySelector('[name="id"]'); return i ? String(i.value) : ''; }
    function pipeQty() {
      var q = form && form.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }
    // The load read shares the tuner's cart; every read after a change is fresh (FL5-04).
    function readCart(fresh) {
      return (fresh ? cartJsonFresh() : cartJsonOnce()).then(function (c) {
        inCart = {};
        ((c && c.items) || []).forEach(function (i) { inCart[String(i.variant_id)] = true; });
      }).catch(function () { /* keep the last known cart */ });
    }
    function fill(s, name) { return String(s || '').replace('[machine]', name); }
    function done(btn, card, after) {
      btn.classList.add('is-done');
      btn.setAttribute('aria-busy', 'false');
      btn.textContent = btn.getAttribute('data-done-text') || 'Added';
      var settled = false;
      var finish = function () { if (settled) return; settled = true; clearTimeout(timer); after(); };
      var timer = setTimeout(finish, 1500);
      returnTo = { card: card, finish: finish };
      goCart();
    }
    function fail(btn, label, err) {
      busy(btn, false);
      btn.textContent = (err && err.message) || 'Could not add';
      setTimeout(function () { btn.innerHTML = label; }, 3000);
    }

    cards.forEach(function (card) {
      var kind = card.getAttribute('data-bgv2-faqx');
      var add = qs('[data-bgv2-faqx-add]', card);
      var status = qs('[data-bgv2-faqx-incart]', card);

      if (kind === 'repack') {
        var kv = card.getAttribute('data-variant');
        var label = add ? add.innerHTML : '';
        var renderKit = function () {
          if (!add || add.classList.contains('is-done')) return;
          var has = !!inCart[kv];
          add.hidden = has;
          if (status) status.hidden = !has;
        };
        renders.push(renderKit);
        if (add) add.addEventListener('click', function () {
          if (add.disabled) return;
          busy(add, true);
          addItems([{ id: kv, quantity: 1 }]).then(function () {
            track('add_to_cart', { item_list_id: 'repack_pdp_faq', items: [{ item_id: card.getAttribute('data-pn') || kv, quantity: 1 }] });
            return setCartAttr('repack_src', 'pdp_faq');
          }).then(function () {
            inCart[kv] = true;
            done(add, card, function () { add.classList.remove('is-done'); busy(add, false); add.innerHTML = label; renderKit(); });
          }).catch(function (err) { fail(add, label, err); });
        });
        return;
      }

      if (kind !== 'tfi') return;
      var boxes = [];
      try { boxes = JSON.parse((qs('[data-bgv2-faqx-boxes]', card) || {}).textContent || '[]'); } catch (e) { boxes = []; }
      var prices = {};
      try { prices = JSON.parse(card.getAttribute('data-prices') || '{}'); } catch (e) { prices = {}; }
      var tags = card.getAttribute('data-product-tags') || '';
      var panes = qsa('[data-bgv2-faqx-pane]', card);
      var el = {
        fit: qs('[data-bgv2-faqx-fit]', card), h: qs('[data-bgv2-faqx-h]', card),
        img: qs('[data-bgv2-faqx-img]', card), title: qs('[data-bgv2-faqx-title]', card),
        pn: qs('[data-bgv2-faqx-pn]', card), price: qs('[data-bgv2-faqx-price]', card),
        other: qs('[data-bgv2-faqx-other]', card), pickLine: qs('[data-bgv2-faqx-pick-line]', card),
        pick: qs('[data-bgv2-faqx-pick]', card), find: qs('[data-bgv2-faqx-garage]', card),
        hedge: qs('[data-bgv2-faqx-hedge]', card)
      };
      var cur = null; // { box, pair, pv }
      function show(name) { panes.forEach(function (p) { p.hidden = p.getAttribute('data-bgv2-faqx-pane') !== name; }); }
      function boxFor(year) { return tfiBoxForYear(boxes, year); }
      // The kinds on offer (FL1-02): Rev Box rows read "Rev Box" in the shared copy, and the TFI fine print is not theirs.
      var boxKinds = boxes.reduce(function (k, r) { var x = r.k || 'tfi'; return !k ? x : (k === x ? k : 'mixed'); }, '');
      var fine = qs('.bgv2-faqx__fine', card);
      function renderTfi() {
        if (add && (add.classList.contains('is-done') || add.getAttribute('aria-busy') === 'true')) return;
        var g = garageRef;
        cur = null;
        if (!g) return show('find');
        var list = g.list() || [];
        if (!list.length) {
          var legacy = typeof g.needsModel === 'function' ? (g.needsModel() || []) : [];
          var Bg = window.BGE || {};
          if (legacy.length && Bg.checkFitment && Bg.parseTags && Bg.checkFitment(Bg.parseTags(tags), legacy[0]) === 'no_fit') {
            // Another make than the pipe (call 73): the box finder link, not a Pick-the-model promise.
            if (el.other) el.other.textContent = fill(card.getAttribute('data-s-other'), [legacy[0].year, legacy[0].make].filter(Boolean).join(' '));
            return show('other');
          }
          if (legacy.length && el.pick) {
            el.pick.setAttribute('data-id', legacy[0].id);
            if (el.pickLine) el.pickLine.textContent = fill(card.getAttribute('data-s-pick'), [legacy[0].year, legacy[0].make].filter(Boolean).join(' '));
            return show('pick');
          }
          return show('find');
        }
        var b = bestOf(g, tags);
        var v = b.vehicle;
        if (b.state === 'no_fit' || b.state === 'wrong_year') {
          var a = g.active() || list[0];
          if (el.other) el.other.textContent = fill(card.getAttribute('data-s-other'), [a.year, a.model].filter(Boolean).join(' '));
          return show('other');
        }
        if (b.state !== 'fits' || !v) return show('find');
        // The year from a saved machine that fits (tuneYear, the tuner row's rule): fitting machines whose years pick
        // different boxes get no one-tap add here, the buy box lists the boxes by year.
        var ty = tuneYear(g, tags, boxes);
        if (!ty.year) {
          if (el.other) el.other.textContent = fill(card.getAttribute('data-s-other'), [v.year, v.model].filter(Boolean).join(' '));
          return show('other');
        }
        v = ty.vehicle;
        var box = boxFor(v.year);
        var short = [v.year, v.model].filter(Boolean).join(' ');
        if (!box) {
          if (el.hedge) el.hedge.textContent = fill(kindText(card.getAttribute('data-s-hedge'), boxKinds), short);
          return show('hedge');
        }
        if (box.a === false) {
          // Sold out for this year (FL1-20): the call-31 line and a link to the box, no add.
          if (el.hedge) {
            var sl = kindText(card.getAttribute('data-s-sold') || 'The Power Box for your [machine] is sold out right now. Call us about tuning.', box.k);
            el.hedge.textContent = fill(sl.replace('{model}', '[machine]'), short) + ' ';
            var sa = document.createElement('a'); sa.href = box.u || '#'; sa.textContent = box.t || ''; el.hedge.appendChild(sa);
          }
          return show('hedge');
        }
        var bk = box.k || 'tfi';
        if (fine) fine.hidden = bk === 'rev';
        var full = window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : '';
        if (el.fit) el.fit.textContent = fill(card.getAttribute('data-s-fit'), full);
        if (el.h) el.h.textContent = fill(card.getAttribute('data-s-h'), short);
        if (el.img) { if (box.img) { el.img.src = box.img; el.img.hidden = false; } else el.img.hidden = true; }
        if (el.title) { el.title.innerHTML = nwTitle(box.t); el.title.href = box.u; }
        if (el.pn) { el.pn.textContent = box.pn ? 'Part # ' + box.pn : ''; el.pn.hidden = !box.pn; }
        if (el.price) el.price.textContent = money(box.p);
        var pv = pipeVariant();
        var pair = !inCart[pv] && Object.prototype.hasOwnProperty.call(prices, pv);
        cur = { box: box, pair: pair, pv: pv };
        var has = !!inCart[String(box.v)];
        if (add) {
          add.hidden = has;
          // looked up each time: done() and fail() rebuild the button's inner HTML
          var label = qs('[data-bgv2-faqx-label]', add), amt = qs('[data-bgv2-faqx-amt]', add);
          if (label) label.textContent = kindText(card.getAttribute(pair ? 'data-s-pair' : 'data-s-one'), bk);
          if (amt) amt.textContent = money(pair ? prices[pv] * pipeQty() + box.p : box.p);
        }
        if (status) status.hidden = !has;
        show('match');
        trackPromoView(card, 'pdp_faq', has ? 'incart' : 'match', box.pn);
      }
      renders.push(renderTfi);

      if (el.find) el.find.addEventListener('click', function (e) {
        if (window.BGE && typeof window.BGE.openGarage === 'function') { e.preventDefault(); window.BGE.openGarage(); }
      });
      if (add) add.addEventListener('click', function () {
        if (add.disabled || !cur || add.closest('[hidden]')) return;
        var c = cur;
        var items = c.pair ? [{ id: c.pv, quantity: pipeQty() }, { id: c.box.v, quantity: 1 }] : [{ id: c.box.v, quantity: 1 }];
        var keep = add.innerHTML;
        busy(add, true);
        track('select_promotion', { promotion_id: 'tfi_pdp_faq', creative_slot: c.pair ? 'pair' : 'box', items: [{ item_id: c.box.pn }] });
        addItems(items).then(function () {
          track('add_to_cart', { item_list_id: 'tfi_pdp_faq', items: [{ item_id: c.box.pn, quantity: 1 }] });
          return c.box.k === 'rev' ? null : setCartAttr('tfi_src', 'pdp_faq');
        }).then(function () {
          items.forEach(function (i) { inCart[String(i.id)] = true; });
          if (c.box.k !== 'rev') tfiSessionAdd('bgv2_tfi_added', card.getAttribute('data-fit'));
          done(add, card, function () { add.classList.remove('is-done'); busy(add, false); add.innerHTML = keep; renderTfi(); });
        }).catch(function (err) { fail(add, keep, err); });
      });
    });

    whenGarage(function (g) {
      if (!g) return;
      garageRef = g;
      renderAll();
      if (typeof g.onChange === 'function') g.onChange(function () { renderAll(); });
    });
    document.addEventListener('bge:garage', function () { renderAll(); });
    document.addEventListener('bgv2:cart:close', function () {
      var r = returnTo;
      returnTo = null;
      if (!r) return;
      // after the drawer's own focus restore: act only when it had nowhere to go. Its target (the add
      // button) is hidden by now, so focus stays on the drawer's close button, which hides 200 ms later.
      setTimeout(function () {
        r.finish();
        var a = document.activeElement;
        var lost = !a || a === document.body || r.card.contains(a) || a.offsetParent === null || !!a.closest('[data-bgv2-cd]');
        if (!lost) return;
        var st = qs('[data-bgv2-faqx-incart]:not([hidden])', r.card);
        var btn = qs('[data-bgv2-faqx-add]:not([hidden])', r.card);
        var target = (st && st.offsetParent !== null) ? st : btn;
        if (target) target.focus();
      }, 0);
    });
    var cartT = 0;
    var reread = function () { clearTimeout(cartT); cartT = setTimeout(function () { readCart(true).then(renderAll); }, 150); };
    document.addEventListener('bgv2:cart:added', reread);
    document.addEventListener('bgv2:cart:change', reread);
    if (form) form.addEventListener('change', function () { setTimeout(renderAll, 0); setTimeout(renderAll, 200); });
    if (readCookie('cart')) readCart().then(renderAll);
  }

  // Desktop PDP aside (bgv2-pdp.css): sticky, capped at the viewport, scrolls on its own. An
  // answer opened near its bottom is brought into view inside the aside, never pushing its
  // question out of view. Nothing happens while the aside fits (phones: it is not a scroller).
  function initAsideReveal() {
    var aside = qs('.bgv2-pdp__aside');
    if (!aside) return;
    // toggle does not bubble; a capturing listener on the aside still hears every <details>
    aside.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.open || aside.scrollHeight <= aside.clientHeight + 1) return;
      var a = aside.getBoundingClientRect(), r = d.getBoundingClientRect();
      if (r.bottom > a.bottom) aside.scrollTop += Math.max(0, Math.min(r.bottom - a.bottom + 16, r.top - a.top - 8));
    }, true);
  }

  // V3 card Add to cart (snippets/bgv3-card). The vendor jQuery delegate on [data-btn-addToCart]
  // posted with no failure path and no double-tap guard (CR-05): a 422, a 429 or a dropped
  // connection did nothing visible, and a double tap added twice. This capture listener claims the
  // card buttons first: one add in flight per button (it stays enabled, so focus stays), success
  // goes to the drawer like the PDP, failure gets a short line in the card's status region.
  // Without JS the form still posts to /cart/add.
  function initCardAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.bgv3-card__btn[data-btn-addToCart]') : null;
      if (!btn || btn.disabled) return;
      var form = btn.form || btn.closest('form');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var card = btn.closest('.bgv3-card');
      var msg = card ? qs('[data-bgv3-card-msg]', card) : null;
      if (msg) msg.textContent = '';
      btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      var hasDrawer = !!window.BGV2CD;
      if (hasDrawer) { fd.append('sections', 'bgv2-cart-drawer'); fd.append('sections_url', '/'); }
      document.dispatchEvent(new CustomEvent('bgv2:cart:adding'));
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) { var err = new Error('add'); err.status = r.status; throw err; }
            return j;
          });
        })
        .then(function (j) {
          btn.removeAttribute('aria-busy');
          if (!hasDrawer) { window.location.href = '/cart'; return; }
          document.dispatchEvent(new CustomEvent('bgv2:cart:added', { detail: { items: j.items || [j], source: 'card', sections: j.sections || null } }));
        })
        .catch(function (err) {
          btn.removeAttribute('aria-busy');
          // Never the raw error: 422 is stock (sold out, or every one we have is already in the cart).
          var text = err && err.status === 422 ? (STR.cardNoStock || 'No more in stock to add right now.') : (STR.cardAddFail || 'Could not add. Try again.');
          if (msg) msg.textContent = text;
        });
    }, true);
  }

  // Back/forward cache. History.js (bundled in vendor.js) binds window unload and beforeunload on every
  // page to save its state store, and any unload listener stops Chrome keeping the page for Back. Only
  // collection pages use History (theme.js AJAX filter, bgv3-collection.js tag links), so elsewhere the
  // three handlers come off. A page restored from the cache shows its old state: the drawer refreshes
  // itself on pageshow (bgv2-cart-drawer.js), and Garage.reload() re-reads storage (bg-garage-ux), so the
  // fit bar, chips and tuner row follow a machine saved on the next page.
  function initBfcache() {
    var H = window.History, $ = window.jQuery;
    if (H && $ && !document.body.classList.contains('template-collection')) {
      var $w = $(window);
      if (typeof H.clearAllIntervals === 'function') $w.off('unload', H.clearAllIntervals);
      if (typeof H.onUnload === 'function') { $w.off('unload', H.onUnload); $w.off('beforeunload', H.onUnload); }
    }
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var G = window.BGE && window.BGE.Garage;
      // reload() emits a change only when storage differs, so a plain Back re-renders nothing
      if (G && typeof G.reload === 'function') { G.reload(); return; }
      try { window.dispatchEvent(new StorageEvent('storage', { key: 'bge_garage_v1' })); } catch (x) { /* old browsers: next load */ }
    });
  }

  function boot() {
    initBfcache();
    initCardAdd();
    initAttribution();
    initSearch();
    initCollectionIntro();
    initGarageLinks();
    initProduct();
    initCompleteSystem();
    initCart();
    initTfiNet();
    initYourScopes();
    initFaqOffers();
    initAsideReveal();
    initFilterMore();
    initSeriesFirst();
    initCookieMessage();
    initZeroReviews();
    initMegaNav();
    initDrawerNav();
    initNavGarage();
    initCredits();
    initFooterAcc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // CTA strategy (Strategy/2026-09/v2-cro/CTA-Colour-Strategy-2026-10-03.md section 6):
  // one delegated listener, bgv2_cta { style, surface, label } for every button. Disabled
  // buttons fire no click, so pointerdown counts the sold-out taps.
  (function ctaTracking() {
    var SEL = '.btn, .bgv2-btn, .product-btn';
    function styleOf(b) {
      if (b.disabled || b.getAttribute('aria-disabled') === 'true' || b.classList.contains('product-btn-soldOut')) return 'disabled';
      if (b.closest('.product-card') && b.closest('.product-card').querySelector('.bge-fitment-badge--no-fit')) return 'addon';
      if (b.matches('.bgv2-tuner__add, .bgv2-net .bgv2-btn, .bgv2-complete .bgv2-btn, .bgv2-btn--addon')) return 'addon';
      if (b.matches('.btn--tertiary, .bgv2-textlink, .cart__update-wrapper .btn--secondary')) return 'tertiary';
      if (b.matches('.bgv2-btn--primary, .btn--primary, .product-form__cart-submit, .cart__submit, .product-btn') && !b.closest('.newsletterSubscription, .card-text-overlay')) return 'primary';
      return 'secondary';
    }
    function surfaceOf(b) {
      var tpl = (document.body.className.match(/template-([a-z0-9_-]+)/) || [])[1] || 'page';
      if (b.closest('.product-card')) return 'card_' + tpl;
      if (b.closest('.bgv2-sticky')) return 'pdp_sticky';
      if (b.closest('.product_shop')) return 'pdp_buybox';
      if (b.closest('.cart-dropdown, .halo_mobileNavigation')) return 'cart_drawer';
      if (b.closest('.cart-template')) return 'cart_page';
      if (b.closest('.slideshow, .bgv2-hero-actions')) return 'hero';
      if (b.closest('.bgv2-finder')) return 'finder';
      return tpl;
    }
    var last = null;
    function fire(e) {
      var b = e.target && e.target.closest && e.target.closest(SEL); if (!b) return;
      if (last === b && e.type === 'click') { last = null; return; }
      last = e.type === 'pointerdown' ? b : null;
      track('bgv2_cta', { style: styleOf(b), surface: surfaceOf(b), label: (b.innerText || b.value || '').replace(/\s+/g, ' ').trim().slice(0, 60) });
    }
    document.addEventListener('pointerdown', fire, true);
    document.addEventListener('click', fire, true);
  })();

  // FL5-07: the blog and article SIDEBAR toggle is a button; theme.js still opens the panel (body.open_Sidebar,
  // .page-sidebar.is-open). aria-expanded follows that class; opening moves focus into the panel (its Close link),
  // and Escape, the Close link or the toggle shut it with focus back on the toggle.
  (function () {
    var tog = document.querySelector('button.sidebar_mobile[aria-controls]');
    if (!tog) return;
    var panel = document.getElementById(tog.getAttribute('aria-controls'));
    var body = document.body, was = false;
    function isOpen() { return body.classList.contains('open_Sidebar'); }
    function sync() {
      var open = isOpen();
      if (open === was) return;
      was = open;
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var f = panel && panel.querySelector('.sidebar_close .close, a[href], button, input, select, textarea');
        if (f) setTimeout(function () { f.focus(); }, 50);
      } else {
        tog.classList.remove('is-open'); // the vendor leaves it on after Close, so the next press would only close
        if (!document.activeElement || document.activeElement === body || (panel && panel.contains(document.activeElement))) tog.focus();
      }
    }
    new MutationObserver(sync).observe(body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      if (panel) panel.classList.remove('is-open');
      body.classList.remove('open_Sidebar');
    });
  })();
})();
